{
  "common": {
    "loading": "טוען...",
    "error": "אירעה שגיאה",
    "save": "שמירה",
    "cancel": "ביטול",
    "confirm": "אישור",
    "back": "חזרה",
    "next": "הבא",
    "submit": "שליחה",
    "search": "חיפוש",
    "filter": "סינון",
    "export": "ייצוא",
    "delete": "מחיקה",
    "edit": "עריכה",
    "view": "צפייה",
    "close": "סגירה",
    "yes": "כן",
    "no": "לא",
    "skip": "דלג",
    "continue": "המשך",
    "print": "הדפסה",
    "download": "הורדה",
    "language": "שפה",
    "saving": "שומר...",
    "previous": "הקודם",
    "retry": "נסה שוב",
    "clear": "ניקוי",
    "actions": "פעולות",
    "showing": "מציג",
    "of": "מתוך",
    "noData": "אין נתונים זמינים",
    "required": "נדרש",
    "optional": "אופציונלי",
    "active": "פעיל",
    "inactive": "לא פעיל",
    "viewAll": "צפה בהכל",
    "apply": "החל",
    "deleting": "מוחק...",
    "saved": "נשמר",
    "add": "הוספה",
    "remove": "הסרה",
    "dismiss": "סגור"
  },
  "nav": {
    "dashboard": "לוח בקרה",
    "patients": "מטופלים",
    "assessments": "הערכות",
    "reports": "דוחות",
    "settings": "הגדרות",
    "help": "עזרה",
    "analytics": "אנליטיקה",
    "clinicSettings": "הגדרות מרפאה",
    "auditLog": "יומן ביקורת",
    "gdpr": "GDPR / נתונים",
    "editProfile": "עריכת פרופיל",
    "myProfile": "הפרופיל שלי",
    "noTitle": "(ללא)",
    "title": "תואר",
    "frontdesk": "קבלה",
    "exercises": "תרגילים",
    "conditions": "מצבים",
    "superadmin": "SuperAdmin",
    "kpi": "פורטל KPI",
    "referralGaps": "פערים במקור ההפניה",
    "staffBoard": "לוח הצוות"
  },
  "auth": {
    "signIn": "התחברות",
    "signOut": "התנתקות",
    "email": "אימייל",
    "password": "סיסמה",
    "forgotPassword": "שכחת סיסמה?",
    "emailPasswordRequired": "נדרשים אימייל וסיסמה",
    "appTitle": "MSK Insight",
    "appSubtitle": "פלטפורמה לתמיכה בהחלטות קליניות",
    "signInSubtitle": "התחבר לחשבון שלך",
    "emailLabel": "כתובת אימייל",
    "emailPlaceholder": "you@clinic.com",
    "passwordPlaceholder": "הזן את הסיסמה שלך",
    "signingIn": "מתחבר…",
    "loginFailed": "ההתחברות נכשלה",
    "footer": "טיפול שלד-שרירי מבוסס ראיות · תואם GDPR"
  },
  "dashboard": {
    "greeting": {
      "morning": "בוקר טוב",
      "afternoon": "אחר צהריים טובים",
      "evening": "ערב טוב"
    },
    "newPatient": "מטופל חדש",
    "newAssessment": "הערכה חדשה",
    "viewAllPatients": "צפה בכל המטופלים",
    "totalPatients": "סה\"כ מטופלים",
    "thisMonth": "החודש",
    "assessments": "הערכות",
    "pendingReviews": "ממתינים לבדיקה",
    "activeCare": "טיפול פעיל",
    "allTime": "כל הזמנים",
    "avgWellness": "ממוצע רווחה",
    "completion": "השלמה",
    "assessmentsPerMonth": "הערכות לפי חודש",
    "noDataYet": "אין נתונים עדיין",
    "topConditions": "אבחנות מובילות",
    "noDiagnoses": "אין אבחנות עדיין",
    "bodyRegionDistribution": "התפלגות אזורי גוף",
    "noRegionData": "אין נתוני אזורים עדיין",
    "fullAnalytics": "אנליטיקה מלאה",
    "needsCompletion": "דורש השלמה",
    "allCaughtUp": "הכל מעודכן! אין הערכות הממתינות להשלמה.",
    "saved": "נשמר ",
    "awaitingFrontDesk": "ממתין לקבלה",
    "frontDeskWorking": "הקבלה עובדת",
    "inProgress": "בתהליך",
    "complete": "הושלם",
    "recentPatients": "מטופלים אחרונים",
    "recentAssessments": "הערכות אחרונות",
    "noPatients": "אין מטופלים עדיין",
    "addFirstPatientMsg": "הוסף את המטופל הראשון שלך כדי להתחיל.",
    "addFirstPatient": "הוסף מטופל ראשון",
    "noVisits": "אין ביקורים",
    "table": {
      "patient": "מטופל",
      "age": "גיל",
      "carePhase": "שלב טיפול",
      "lastVisit": "ביקור אחרון",
      "clinician": "רופא",
      "status": "סטטוס",
      "date": "תאריך"
    },
    "stable": "יציב",
    "onTrack": "במסלול",
    "last6Months": "6 חודשים אחרונים"
  },
  "patient": {
    "new": "מטופל חדש",
    "search": "חיפוש מטופלים",
    "firstName": "שם פרטי",
    "lastName": "שם משפחה",
    "dateOfBirth": "תאריך לידה",
    "phone": "טלפון",
    "email": "אימייל",
    "carePhase": "שלב טיפול"
  },
  "patients": {
    "title": "מטופלים",
    "newPatient": "+ מטופל חדש",
    "searchPlaceholder": "חיפוש לפי שם, MRN, טלפון...",
    "allPhases": "כל השלבים",
    "initial": "ראשוני",
    "activeCare": "טיפול פעיל",
    "maintenance": "תחזוקה",
    "wellness": "בריאות",
    "noFound": "לא נמצאו מטופלים",
    "table": {
      "name": "שם",
      "mrn": "MRN",
      "dob": "תאריך לידה",
      "phone": "טלפון",
      "carePhase": "שלב טיפול",
      "lastUpdated": "עדכון אחרון"
    },
    "guardian": "אפוטרופוס",
    "total": "מטופלים",
    "firstName": "שם פרטי",
    "lastName": "שם משפחה",
    "status": {
      "active": "פעיל",
      "doNotContact": "לא ליצור קשר"
    },
    "typeahead": {
      "loading": "…מחפש",
      "empty": "לא נמצאו מטופלים",
      "error": "החיפוש אינו זמין כרגע",
      "lastSeen": "אחרון",
      "nextSeen": "הבא",
      "lastAppt": "תור אחרון:",
      "nextAppt": "תור הבא:"
    },
    "loadError": {
      "title": "לא ניתן היה לטעון את המטופלים.",
      "body": "משהו השתבש אצלנו. נסו שוב בעוד רגע.",
      "unavailable": "נתוני המטופלים אינם זמינים כרגע. נסו שוב בקרוב.",
      "retry": "נסו שוב"
    }
  },
  "patientDetail": {
    "backToPatients": "חזרה למטופלים",
    "startAssessment": "התחל הערכה",
    "patientInfo": "פרטי מטופל",
    "dateOfBirth": "תאריך לידה",
    "gender": "מגדר",
    "phone": "טלפון",
    "email": "אימייל",
    "language": "שפה",
    "carePhase": "שלב טיפול",
    "registered": "נרשם",
    "assessments": "הערכות",
    "noAssessments": "אין הערכות עדיין. לחץ על \"התחל הערכה\" כדי להתחיל.",
    "continueAssessment": "המשך הערכה",
    "notFound": "המטופל לא נמצא",
    "step": "שלב",
    "reexam": {
      "title": "נמצאה הערכה קודמת",
      "message": "למטופל זה יש הערכה קודמת מתאריך {{date}}. מה תרצה:",
      "startReexam": "התחל בדיקה חוזרת",
      "reexamDesc": "השוואה עם הערכה קודמת. תלונות קיימות טעונות מראש. ניתן להוסיף חדשות.",
      "startNew": "הערכה חדשה",
      "newDesc": "הערכה מלאה חדשה — סיבת ביקור שונה או הצגה קלינית חדשה."
    },
    "deleteModal": {
      "title": "מחיקת מטופל",
      "message": "האם אתה בטוח שברצונך למחוק לצמיתות את {{name}} ואת כל ההערכות? פעולה זו לא ניתנת לביטול.",
      "typeToConfirm": "הקלד את שם המשפחה של המטופל ({{lastName}}) לאישור:",
      "deleting": "מוחק..."
    },
    "needsRepair": {
      "title": "רשומת המטופל הזו דורשת תיקון",
      "body": "חלק מהרשומה הזו אינו ניתן לקריאה כרגע. הבעיה דווחה ודבר לא שונה. אין ליצור את המטופל מחדש — פנו לתמיכה אם אתם צריכים את הרשומה הזו היום."
    },
    "loadFailed": "לא ניתן היה לטעון את המטופל."
  },
  "patientForm": {
    "editTitle": "עריכת מטופל",
    "newTitle": "מטופל חדש",
    "firstNameLabel": "שם פרטי *",
    "lastNameLabel": "שם משפחה *",
    "dateOfBirthLabel": "תאריך לידה *",
    "genderLabel": "מגדר",
    "selectGender": "בחר...",
    "male": "זכר",
    "female": "נקבה",
    "other": "אחר",
    "phoneLabel": "טלפון",
    "emailLabel": "אימייל",
    "languageLabel": "שפה",
    "english": "אנגלית",
    "greek": "יוונית",
    "russian": "רוסית",
    "hebrew": "עברית",
    "carePhaseLabel": "שלב טיפול",
    "initial": "ראשוני",
    "activeCare": "טיפול פעיל",
    "maintenance": "תחזוקה",
    "wellness": "בריאות",
    "saving": "שומר...",
    "updatePatient": "עדכן מטופל",
    "createPatient": "צור מטופל",
    "guardianLabel": "אפוטרופוס / הורה",
    "relationshipLabel": "קרבה למטופל",
    "selectRelationship": "בחר קרבה",
    "mother": "אם",
    "father": "אב",
    "legalGuardian": "אפוטרופוס חוקי",
    "carer": "מטפל",
    "minorWarning": "המטופל מתחת לגיל 18 ({{age}} {{unit}}) — נדרש מידע על אפוטרופוס",
    "guardianNamePlaceholder": "לדוגמה: שרה כהן",
    "dayPlaceholder": "יי",
    "monthPlaceholder": "חח",
    "yearPlaceholder": "שששש",
    "errors": {
      "required": "שם פרטי, שם משפחה ותאריך לידה נדרשים",
      "saveFailed": "שגיאה בשמירת מטופל",
      "guardianRequired": "שם אפוטרופוס / הורה נדרש עבור מטופלים מתחת לגיל 18",
      "genderRequired": "מין נדרש"
    },
    "contactInfo": "פרטי יצירת קשר",
    "editDescription": "עדכן את פרטי המטופל",
    "newDescription": "מלא את הפרטים לרישום מטופל חדש",
    "personalInfo": "מידע אישי",
    "preferences": "העדפות"
  },
  "aiPaste": {
    "analyze": "נתח באמצעות בינה מלאכותית",
    "analyzing": "מנתח...",
    "aiTruncated": "ניתוח ה-AI לא הושלם — תשובת ה-AI חרגה מהמכסה הזמינה. בוצע כבר ניסיון חוזר אוטומטי. נסו שוב; בהיסטוריה ארוכה מאוד, הדבקת קטע קצר יותר יכולה לעזור. אפשר גם לעבור לשאלון המודרך.",
    "examSkippedTitle": "{{count}} תוצאות בדיקה לא ניתן היה לשמור והן לא נרשמו:",
    "examSkippedUnknownKey": "הבדיקה הזו אינה בקטלוג הבדיקות",
    "examSkippedInvalidResult": "ערך התוצאה לא זוהה",
    "examSkippedHelp": "כל השאר נשמר. רשמו אותן בשלב הבדיקה אם מדובר בממצאים אמיתיים.",
    "removedTitle": "{{count}} תלונות מוצעות הוסרו על ידי בדיקת התקינות:",
    "removedExamDerived": "הוסר: נגזר מממצאי בדיקה",
    "removedNoEvidence": "הוסר: אין תיעוד מילולי ברשומות",
    "strippedNegatives": "חלק מהצהרות «אין ...» היו ללא תימוכין ברשומות שלכם והוסרו. אלרגיות ללא סטטוס מוצהר מוצגות כלא מתועדות.",
    "deadline": "ניתוח ה-AI נמשך זמן רב מדי ונעצר לאחר 150 שניות. דבר מהניסיון הזה לא נשמר. נסו שוב, או עברו לשאלון המודרך.",
    "retry": "נסה שוב",
    "clientTimeout": "ניתוח ה-AI לא הגיב בזמן ולכן נעצר. דבר מהניסיון הזה לא הוחל. נסו שוב, או עברו לשאלון המודרך."
  },
  "holistic": {
    "invalid": "הניתוח הקליני של ה-AI לא הושלם — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "longWait": "עדיין בעבודה — ייתכן שה-AI מבצע ניסיון שני. זה עשוי להימשך עד שתי דקות.",
    "takes": "בדרך כלל זה לוקח פחות מדקה",
    "retry": "נסו שוב",
    "notGenerated": "ניתוח קליני של AI לא נוצר עבור הערכה זו.",
    "notGeneratedInvalid": "ניתוח ה-AI השמור היה חלקי והוסר. צרו אותו מחדש כשתהיו מוכנים.",
    "regenerate": "צור ניתוח",
    "saveFailed": "לא ניתן היה לשמור את הניתוח ההוליסטי. העריכות שלכם לא נשמרו — אנא נסו שוב."
  },
  "aiCaller": {
    "soapInvalid": "רשומת ה-SOAP של ה-AI לא הושלמה — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "summaryInvalid": "סיכום ה-AI לא הושלם — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "secondOpinionInvalid": "חוות הדעת השנייה של ה-AI לא הושלמה — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "letterInvalid": "מכתב ה-AI לא הושלם — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "retry": "נסו שוב",
    "translationInvalid": "תרגום הדוח לא הושלם — תשובת ה-AI הייתה חלקית, שגויה או לא בשפת היעד. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "uploadTextInvalid": "סיכום הקובץ לא הושלם — תשובת ה-AI הייתה חלקית. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב.",
    "postureExtractInvalid": "חילוץ PostureScreen לא הושלם — תשובת ה-AI הייתה חלקית או שגויה. כבר בוצע ניסיון חוזר אוטומטי. אנא נסו שוב."
  },
  "assessment": {
    "new": "הערכה חדשה",
    "resume": "המשך",
    "complete": "הושלם",
    "draft": "טיוטה",
    "fullAssessment": "הערכה מלאה",
    "quickScore": "ציון מהיר",
    "reExam": "בדיקה חוזרת",
    "steps": {
      "medicalHistory": "היסטוריה רפואית",
      "chiefComplaints": "תלונות עיקריות",
      "physicalExamination": "בדיקה גופנית",
      "postureAnalysis": "ניתוח יציבה",
      "investigations": "בדיקות",
      "outcomeMeasures": "מדדי תוצאה",
      "ddxReview": "סקירת DDx",
      "managementPlan": "תוכנית טיפול",
      "reportGeneration": "יצירת דוח"
    },
    "readOnly": "הערכה זו הושלמה והיא לקריאה בלבד.",
    "completedBy": "שלבים אלה הושלמו על ידי {{name}}. צור קשר לשינויים.",
    "completedByClinician": "שלבים אלה הושלמו על ידי הרופא. צור קשר לשינויים.",
    "bodyMap": {
      "instruction": "לחץ על אזורי הגוף בהם למטופל יש כאב או תסמינים. בחר עד 5 אזורים.",
      "noRegions": "לא נבחרו אזורים",
      "regionsSelected": "{{count}} אזור(ות) נבחר(ו)",
      "startDetail": "התחל פירוט תלונה",
      "editRegions": "ערוך אזורים",
      "regions": "אזורים: "
    },
    "redFlags": {
      "title": "זוהו דגלים אדומים",
      "requireAction": "הדגלים האדומים הבאים דורשים פעולה מהרופא לפני המשך.",
      "clear": "בדיקת דגלים אדומים הושלמה. לא נמצאו בעיות הדורשות פעולה מיידית.",
      "instruction": "ענה כן או לא על כל שאלת סינון. נשאלים פעם אחת לכל ההערכה.",
      "backToComplaints": "חזרה לתלונות",
      "submitting": "שולח...",
      "submitAndContinue": "שלח סינון והמשך"
    },
    "saveAsDraft": "שמור כטיוטה — הקבלה תשלים",
    "continueToReport": "המשך ליצירת דוח",
    "finalize": {
      "instruction": "כאשר כל הסעיפים מוכנים, סיים את הדוח כדי לסמן אותו כהושלם.",
      "button": "סיים דוח",
      "success": "הדוח הושלם ומוכן למטופל. מעביר ללוח הבקרה…"
    },
    "stepComingSoon": "שלב {{step}} — בקרוב.",
    "loadingAssessment": "טוען הערכה…",
    "goBack": "חזור",
    "noPatient": "לא נבחר מטופל. התחל הערכה מפרופיל המטופל.",
    "viewPatients": "צפה במטופלים",
    "finalized": "הושלם",
    "navigation": {
      "previousSection": "הסעיף הקודם",
      "continueTo": "המשך ל{{step}}",
      "nextSection": "הסעיף הבא",
      "completeAssessment": "השלם הערכה",
      "saveAndContinueTo": "שמור והמשך ל{{step}}"
    }
  },
  "clinical": {
    "findings": "ממצאים קליניים",
    "observations": "תצפיות",
    "workingHypothesis": "השערת עבודה",
    "assessment": "הערכה",
    "aiSuggested": "הצעת AI — ממתין לאישור רופא",
    "confirmedBy": "אושר על ידי רופא",
    "redFlag": "דגל אדום — דורש תשומת לב מיידית"
  },
  "medicalHistory": {
    "title": "היסטוריה רפואית",
    "pastMedical": "היסטוריה רפואית קודמת",
    "currentMedications": "תרופות נוכחיות",
    "allergies": "אלרגיות",
    "lifestyle": "הערכת אורח חיים",
    "familyHistory": "היסטוריה משפחתית",
    "socialHistory": "היסטוריה חברתית",
    "surgicalHistory": "היסטוריה כירורגית",
    "reviewOfSystems": "סקירת מערכות",
    "noConditions": "לא דווחו מצבים רפואיים",
    "noMedications": "אין תרופות נוכחיות",
    "noAllergies": "אין אלרגיות ידועות",
    "addCondition": "הוסף מצב רפואי",
    "addMedication": "הוסף תרופה",
    "addAllergy": "הוסף אלרגיה",
    "condition": "מצב רפואי",
    "medication": "תרופה",
    "dosage": "מינון",
    "frequency": "תדירות",
    "allergen": "אלרגן",
    "reaction": "תגובה",
    "severity": "חומרה",
    "mild": "קל",
    "moderate": "בינוני",
    "severe": "חמור",
    "occupation": "מקצוע",
    "smokingStatus": "סטטוס עישון",
    "alcoholUse": "שימוש באלכוהול",
    "exerciseLevel": "רמת פעילות גופנית",
    "never": "אף פעם",
    "former": "לשעבר",
    "current": "נוכחי",
    "none": "ללא",
    "light": "קל",
    "heavy": "כבד",
    "sedentary": "יושבני",
    "active": "פעיל",
    "veryActive": "פעיל מאוד",
    "saveAndContinue": "שמור והמשך לתלונות",
    "treatmentGoals": "יעדי טיפול",
    "pastMsk": "מצבים שלד-שריריים קודמים",
    "medications": "תרופות נוכחיות",
    "systemsReview": "סקירת מערכות",
    "loading": "טוען היסטוריה רפואית...",
    "noSurgical": "לא נרשמה היסטוריה כירורגית.",
    "noFamily": "לא נרשמה היסטוריה משפחתית.",
    "searchMedications": "חיפוש תרופות",
    "year": "שנה",
    "selectBodyRegion": "בחר אזור גוף",
    "procedureName": "שם הפרוצדורה",
    "allergenName": "שם האלרגן",
    "pregnancyStatus": "סטטוס הריון",
    "additionalNotes": "מצבים נוספים או הערות",
    "shortPastMsk": "היסט. שלד",
    "shortMedications": "תרופות",
    "shortSurgical": "ניתוחים",
    "shortFamily": "משפחה",
    "shortSystems": "מערכות",
    "shortAllergies": "אלרגיות",
    "shortLifestyle": "אורח חיים",
    "birthSummary": "סיכום לידה",
    "mothersHealth": "בריאות האם",
    "immunisations": "חיסונים",
    "shortBirth": "לידה",
    "shortMother": "אם",
    "shortVaccines": "חיסונים",
    "noCurrentMeds": "אין תרופות נוכחיות",
    "addFamilyCondition": "הוסף מצב משפחתי",
    "noFamilyHistory": "לא נרשמה היסטוריה משפחתית.",
    "systemsToggleDesc": "החלף כל מערכת כדי לציין ממצאים חיוביים, ולאחר מכן הוסף הערות.",
    "notesPlaceholder": "הערות עבור ממצאי {{system}}...",
    "pregnancyTitle": "מצב הריון",
    "notPregnant": "לא בהריון",
    "currentlyPregnant": "בהריון כעת",
    "possiblyPregnant": "ייתכן בהריון",
    "unknown": "לא ידוע"
  },
  "complaints": {
    "title": "תלונות עיקריות",
    "side": "צד",
    "painLevel": "רמת כאב (NRS)",
    "onset": "התחלה",
    "nature": "אופי הכאב",
    "aggravating": "גורמים מחמירים",
    "relieving": "גורמים מקלים",
    "radiation": "דפוס הקרנה",
    "dermatome": "התפלגות דרמטומלית",
    "neuroSymptoms": "תסמינים נוירולוגיים",
    "functionalImpact": "השפעה תפקודית",
    "whichSide": "באיזה צד הכאב?",
    "left": "שמאל",
    "right": "ימין",
    "bilateral": "דו-צדדי",
    "central": "מרכזי/קו אמצע",
    "noPain": "ללא כאב",
    "worstPain": "כאב הגרוע ביותר",
    "sudden": "פתאומי",
    "gradual": "הדרגתי",
    "sharp": "חד",
    "dull": "עמום",
    "aching": "כואב",
    "burning": "צורב",
    "shooting": "יורה",
    "throbbing": "פועם",
    "stabbing": "דוקר",
    "doesRadiate": "האם הכאב מקרין?",
    "whereRadiate": "לאן בדיוק הכאב מקרין?",
    "region": "אזור",
    "question": "שאלה",
    "newComplaint": "חדש",
    "newComplaintNote": "זוהי תלונה חדשה (לא הייתה קיימת בהערכה הקודמת)",
    "noRegionsSelected": "לא נבחרו אזורי גוף",
    "loadingComplaint": "טוען נתוני תלונה...",
    "saveAndContinue": "שמור והמשך לדגלים אדומים",
    "complaintReview": "סקירת תלונות",
    "aiParsedBadge": "נותח על ידי AI · הקש לאישור",
    "confirmError": "לא ניתן לאשר — נסה שוב",
    "reviewInstructions": "סקור תלונות שנשמרו. ניתן להוסיף אזור תלונה נוסף או להמשיך לסינון דגלים אדומים.",
    "loadingComplaints": "טוען תלונות...",
    "noComplaintsSaved": "עדיין לא נשמרו תלונות. הוסף לפחות תלונה אחת.",
    "painLabel": "כאב: {{score}}/10",
    "addAnother": "+ הוסף תלונה נוספת",
    "maxReached": "הגעת למקסימום 5 תלונות",
    "editRedFlags": "ערוך תשובות דגלים אדומים",
    "continueToRedFlags": "המשך לסינון דגלים אדומים →",
    "complaintsCount": "{{count}} תלונה(ות) נשמרו",
    "bodyMapInstructions": "לחץ על אזורי הגוף בהם למטופל יש כאב או תסמינים. בחר עד 5 אזורים.",
    "regionsSelected": "{{count}} אזור(ות) נבחר(ו)",
    "startComplaintDetail": "התחל פירוט תלונה →",
    "editRegions": "← ערוך אזורים",
    "chronicity": "כמה זמן יש לך תלונה זו?",
    "haLocation": "היכן ממוקם כאב הראש שלך?",
    "haCharacter": "כיצד היית מתאר את כאב הראש?",
    "haDuration": "כמה זמן נמשך כל אירוע?",
    "haFrequency": "באיזו תדירות יש לך כאבי ראש?",
    "haAssociated": "האם אתה חווה משהו מאלה עם כאב הראש שלך?",
    "haTriggers": "מה מעורר או מחמיר את כאב הראש שלך?",
    "haRelief": "מה עוזר להקל על כאב הראש שלך?",
    "redFlagScreening": "סינון דגלים אדומים",
    "dzType": "כיצד היית מתאר את הסחרחורת שלך?",
    "dzTiming": "כמה זמן נמשך כל אירוע?",
    "dzPosition": "האם הסחרחורת שלך מושפעת מתנוחה?",
    "dzAssociated": "האם אתה חווה משהו מאלה עם הסחרחורת שלך?",
    "dzTriggers": "מה מעורר את הסחרחורת שלך?",
    "paedReporter": "מי מדווח על התסמינים?",
    "paedDailyImpact": "השפעה על פעילויות יומיומיות",
    "paedRecentHistory": "היסטוריה אחרונה",
    "paedDevelopmental": "שיקולי התפתחות",
    "paedFamilyHistory": "היסטוריה משפחתית (ילדים)",
    "selectDuration": "בחר את משך התסמינים",
    "noDestinations": "אין יעדים ספציפיים לאזור זה.",
    "selectDermatome": "בחר את התפלגות הדרמטום (אם ניתן לזהות):",
    "selectAllApply": "בחר את כל המתאימים",
    "selectAllApplyMultiType": "בחר את כל המתאימים — מטופלים עשויים לחוות יותר מסוג אחד",
    "selectAllApplyDuration": "בחר את כל המתאימים — אירועים עשויים להשתנות במשך",
    "selectTypicalDuration": "בחר את המשך האופייני של כל אירוע",
    "selectTypicalFrequency": "בחר את התדירות האופיינית",
    "redFlagInstructions": "ענה כן או לא על כל שאלה. כל תשובת \"כן\" עשויה להצביע על צורך בהפניה דחופה.",
    "clinicalNote": "הערה קלינית",
    "paedReporterHint": "מי מדווח על התסמינים?",
    "paedDailyImpactHint": "כיצד הכאב משפיע על הפעילויות היומיומיות של ילדך? בחר את כל המתאימים.",
    "paedRecentHistoryHint": "שינויים אחרונים? בחר את כל המתאימים.",
    "paedDevelopmentalHint": "שיקולי התפתחות? בחר את כל המתאימים.",
    "paedFamilyHistoryHint": "היסטוריה משפחתית רלוונטית? בחר את כל המתאימים.",
    "centralMidline": "מרכזי/קו אמצע",
    "centralFrontal": "מרכזי/מצחי",
    "occipital": "עורפי",
    "onsetTraumatic": "טראומטי",
    "onsetInsidious": "הדרגתי סמוי",
    "onsetPostSurgical": "לאחר ניתוח",
    "onsetRepetitiveStrain": "עומס חוזר",
    "onsetUnknown": "לא ידוע",
    "chronicityAcute": "פחות משבועיים (חריפה)",
    "chronicitySubacute": "2–6 שבועות (תת-חריפה)",
    "chronicityChronic": "6–12 שבועות (כרונית)",
    "chronicityChronicLong": "יותר מ-12 שבועות (כרונית)",
    "cramping": "התכווצות",
    "tingling": "עקצוץ",
    "numbness": "חוסר תחושה",
    "radiationNone": "אין",
    "radiationArm": "לזרוע",
    "radiationLeg": "לרגל",
    "radiationBack": "לאורך הגב",
    "radiationShoulder": "לכתף",
    "radiationHand": "ליד/אצבעות",
    "radiationFoot": "לכף רגל/אצבעות",
    "radiationChest": "סביב בית החזה",
    "radiationGroin": "למפשעה",
    "radiationButtock": "לישבן",
    "neuroWeakness": "חולשה",
    "neuroBalance": "אובדן שיווי משקל",
    "neuroCoordination": "אובדן קואורדינציה",
    "neuroAlteredSensation": "תחושה שונה",
    "impactUnableWork": "אי יכולת לעבוד",
    "impactReducedWork": "כושר עבודה מופחת",
    "impactSleeping": "קושי בשינה",
    "impactDaily": "קושי בפעילויות יומיומיות",
    "impactSelfCare": "קושי בטיפול עצמי",
    "impactExercise": "אי יכולת להתאמן",
    "impactMobility": "ניידות מופחתת",
    "impactSocial": "נסיגה חברתית",
    "impactMood": "השפעה על מצב הרוח",
    "impactNone": "אין השפעה משמעותית",
    "haLocOneSame": "צד אחד בלבד (תמיד אותו צד)",
    "haLocOneAlt": "צד אחד (צדדים מתחלפים)",
    "haLocBoth": "שני הצדדים / בכל מקום",
    "haLocBack": "אחורי הראש / בסיס הגולגולת",
    "haLocForehead": "מצח / מאחורי העיניים",
    "haLocTemple": "אזור הרקה",
    "haLocTop": "קדקוד",
    "haCharThrobbing": "פועם",
    "haCharPressing": "לוחץ / מהדק (כמו חישוק)",
    "haCharSharp": "חד / דוקר",
    "haCharDull": "עמום / כואב",
    "haDurSeconds": "שניות עד דקות",
    "haDur30min": "30 דקות עד 4 שעות",
    "haDur4h": "4 עד 72 שעות",
    "haDurConstant": "קבוע / תמיד נוכח",
    "haDurVariable": "משתנה",
    "haFreqDaily": "יומי או כמעט יומי",
    "haFreqSeveral": "מספר פעמים בשבוע",
    "haFreqWeekly": "שבועי",
    "haFreqMonthly": "חודשי או פחות",
    "haFreqEpisodic": "אפיזודי / בא והולך",
    "startFromTemplate": "התחל מתבנית",
    "hideMap": "הסתר מפת כאב",
    "markLocation": "סמן מיקום כאב מדויק (אופציונלי)"
  },
  "physicalExam": {
    "title": "בדיקה גופנית",
    "selectTests": "בחר בדיקות לביצוע",
    "recommended": "מומלץ",
    "performed": "בוצע",
    "notPerformed": "לא בוצע",
    "positive": "חיובי",
    "negative": "שלילי",
    "inconclusive": "לא חד-משמעי",
    "notes": "הערות",
    "addNotes": "הוסף הערות...",
    "testResult": "תוצאת בדיקה",
    "saveResults": "שמור תוצאות",
    "noTestsSelected": "לא נבחרו בדיקות",
    "selectRegion": "בחר אזור גוף לצפייה בבדיקות זמינות",
    "allTests": "כל הבדיקות",
    "essentialTests": "בדיקות חיוניות",
    "recommendedTests": "בדיקות מומלצות",
    "differentialTests": "בדיקות אבחנה מבדלת",
    "additionalTests": "בדיקות נוספות",
    "clinicalGuide": "מדריך הערכה קלינית",
    "patternMatch": "התאמת דפוס",
    "match": "התאמה",
    "basedOnPresentation": "מבוסס על ניתוח הצגה קלינית",
    "showProcedureDetails": "הצג פרטי הליך",
    "primaryTests": "בדיקות ראשוניות",
    "secondaryTests": "בדיקות משניות",
    "romSpecialized": "ROM / מתמחה",
    "notTested": "לא נבדק",
    "left": "שמאל",
    "right": "ימין",
    "bilateral": "דו-צדדי",
    "normal": "תקין",
    "restricted": "מוגבל",
    "painful": "כואב",
    "hypermobile": "היפרמוביליות",
    "noAbnormalities": "לא נמצאו ממצאים חריגים",
    "noSpinalDysfunction": "לא נמצאה הפרעה עמוד שדרה",
    "collapse": "כווץ",
    "expand": "הרחב",
    "hideNotes": "הסתר הערות",
    "clinicalNotes": "הערות קליניות...",
    "searchTests": "חפש בדיקות לפי שם...",
    "all": "הכל",
    "essentialDesc": "חובה לבצע — קריטי לאישור/שלילת אבחנות ראשוניות",
    "recommendedDesc": "מומלץ לבצע — מחזק את החשיבה הקלינית",
    "additionalDesc": "במידת הצורך — בהתאם למורכבות המקרה"
  },
  "posture": {
    "manualAssessment": "הערכה ידנית",
    "cameraAssessment": "הערכה במצלמה",
    "shoulderROM": "טווח תנועה של כתף",
    "advancedMeasurements": "מדידות מתקדמות (14 מדדים)",
    "removeImage": "הסר תמונה",
    "cameraDataPopulated": "נתוני מצלמה הוזנו"
  },
  "investigations": {
    "title": "בדיקות",
    "description": "העלה הדמיה (רנטגן, MRI, CT) ו/או הזן תוצאות מעבדה. שני הסעיפים אופציונליים.",
    "skipAll": "דלג על הכל",
    "imaging": "הדמיה (רנטגן, MRI, CT, אולטרסאונד)",
    "labTests": "בדיקות מעבדה (בדיקות דם, סמנים)"
  },
  "improvement": {
    "previous": "קודם",
    "current": "נוכחי",
    "noData": "אין נתונים",
    "significantImprovement": "שיפור משמעותי",
    "moderateImprovement": "שיפור מתון",
    "declining": "הידרדרות",
    "stable": "יציב",
    "mcidMet": "MCID ✓",
    "loading": "טוען דוח שיפור...",
    "noComparisonData": "אין נתוני השוואה זמינים.",
    "reportTitle": "דוח שיפור בדיקה חוזרת",
    "comparisonSubtitle": "השוואה עם הערכה קודמת",
    "printReport": "הדפס דוח",
    "painSeverityChanges": "שינויים בעוצמת הכאב",
    "outcomeMeasureChanges": "שינויים במדדי תוצאה",
    "clinicallySignificantChanges": "שינויים משמעותיים קלינית",
    "wellnessScore": "ציון ביצועי הגוף",
    "mcidExplanation": "MCID = הבדל קליני מינימלי משמעותי. שינויים העומדים או חורגים מ-MCID נחשבים משמעותיים קלינית.",
    "loadError": "נכשלה טעינת נתוני ההשוואה",
    "descNoMeasures": "אין מדדים זמינים להשוואה.",
    "descImproved": "{{improved}} מתוך {{total}} מדדים השתפרו.",
    "descModerate": "{{improved}} מתוך {{total}} מדדים השתפרו, {{worsened}} החמירו.",
    "descDeclining": "{{worsened}} מתוך {{total}} מדדים החמירו. שקול שינוי תוכנית.",
    "descMixed": "תוצאות מעורבות: {{improved}} השתפרו, {{worsened}} החמירו, {{unchanged}} ללא שינוי."
  },
  "reexam": {
    "improved": "השתפר",
    "worsened": "החמיר",
    "noChange": "ללא שינוי",
    "noMeasures": "אין מדדי תוצאה להצגה."
  },
  "paediatricReEvalReport": {
    "title": "דוח ההתקדמות של הילד שלכם",
    "yearsOld": "בן/בת {{age}}",
    "reEvalFollowup": "הערכה חוזרת — ביקור מעקב",
    "dearParents": "הורים יקרים,",
    "introText": "תודה שהבאתם את {{name}} לביקור המעקב. אנו שמחים לשתף אתכם כיצד הוא/היא מתקדם/ת ומהם השלבים הבאים בטיפול.",
    "howChildIsDoing": "איך {{name}} מרגיש/ה",
    "lastVisit": "הביקור הקודם",
    "today": "היום",
    "improvement": "שיפור",
    "painImprovementMessage": "זהו שיפור של {{pct}}%! התקדמות מצוינת.",
    "greatNews": "חדשות טובות!",
    "improvingMessage": "אנו שמחים לשמוע ש{{name}} מרגיש/ה טוב יותר.",
    "muchBetterNote": "השיפור המשמעותי מראה שהגוף מגיב היטב לטיפול.",
    "worseMessage": "אנו מבינים שזה יכול להיות מדאיג. חשוב לזכור שההתקדמות אינה תמיד לינארית, במיוחד אצל ילדים. נסביר מה מצאנו היום וכיצד אנו מתאימים את התוכנית כדי לעזור ל{{name}}.",
    "noChangeMessage": "אף על פי שהתסמינים טרם השתנו משמעותית, זה נפוץ בשלבים המוקדמים של הטיפול. אנו עוקבים בקפידה אחר התקדמותו/ה של {{name}} ומתאימים את התוכנית בהתאם.",
    "developmentalProgress": "התקדמות התפתחותית",
    "whatWeFoundToday": "מה מצאנו היום",
    "whatWeFoundIntro": "להלן סיכום המצבים הנוכחיים של {{name}} וההתקדמות שלהם:",
    "statusImproving": "משתפר",
    "statusStable": "יציב",
    "statusNeedsAttention": "דורש תשומת לב",
    "statusUnderReview": "בבחינה",
    "monitoring": "אנו עוקבים אחר מצב זה כחלק מתוכנית הטיפול של {{name}}.",
    "noConditionsConfirmed": "לא אושרו מצבים ספציפיים בשלב זה.",
    "updatedTreatmentPlan": "תוכנית הטיפול המעודכנת של {{name}}",
    "updatedPlanIntro": "בהתבסס על הממצאים של היום, להלן התוכנית המעודכנת לטיפול ב{{name}}:",
    "whatYouCanDoAtHome": "מה אתם יכולים לעשות בבית",
    "infantTitle": "המלצות לתינוקות (0-1 שנה)",
    "infantTummyTime": "זמן על הבטן:",
    "infantTummyTimeText": "3-5 דקות מספר פעמים ביום, תוך הגדלה הדרגתית",
    "infantFeeding": "האכלה:",
    "infantFeedingText": "החליפו צדדים במהלך ההאכלה לעידוד תנועה סימטרית",
    "infantCarrying": "נשיאה:",
    "infantCarryingText": "גוונו תנוחות נשיאה — על הירך, פנים קדימה, ישיבה נתמכת",
    "infantSleep": "שינה:",
    "infantSleepText": "שכיבה על הגב לשינה, החלפת תנוחת הראש בכל שנת יום",
    "infantPlay": "משחק:",
    "infantPlayText": "השתמשו בצעצועים לעידוד הושטה ופנייה לשני הצדדים",
    "toddlerTitle": "המלצות לפעוטות (1-3 שנים)",
    "toddlerMovement": "תנועה:",
    "toddlerMovementText": "עודדו טיפוס, זחילה במנהרות ופעילויות שיווי משקל",
    "toddlerShoes": "נעליים:",
    "toddlerShoesText": "בחרו נעליים גמישות ותומכות — יחפים בבית כשזה בטוח",
    "toddlerWalking": "דפוסי הליכה:",
    "toddlerWalkingText": "הליכה קלה על קצות האצבעות או פנימה נפוצה בגיל זה",
    "toddlerActivities": "פעילויות:",
    "toddlerActivitiesText": "ריקוד, משחק בכדור רך וקפיצות עדינות עוזרים לקואורדינציה",
    "childTitle": "המלצות לילדים (3-12 שנים)",
    "childSport": "ספורט ופעילות:",
    "childSportText": "עודדו 60 דקות של פעילות גופנית מדי יום — מגוון הוא הטוב ביותר",
    "childBackpack": "תיק גב:",
    "childBackpackText": "משקל לא יותר מ-10-15% ממשקל הגוף, עם שתי רצועות",
    "childScreen": "יציבה מול מסך:",
    "childScreenText": "עיניים בגובה המסך, רגליים על הרצפה, הפסקות כל 20-30 דקות",
    "childFun": "תרגילים מהנים:",
    "childFunText": "«הליכות חיות» (דוב, סרטן), «תנוחות גיבור-על» ו-«מלאכים על הקיר»",
    "childRest": "מנוחה לעומת פעילות:",
    "childRestText": "אם הכאב קל, פעילות עדינה בדרך כלל עוזרת יותר ממנוחה מלאה",
    "adolescentTitle": "המלצות למתבגרים (12-18 שנים)",
    "adolescentSport": "ספציפי לספורט:",
    "adolescentSportText": "חימום כראוי, לא לשחק עם כאב משמעותי",
    "adolescentGrowth": "קפיצות גדילה:",
    "adolescentGrowthText": "מתיחות נוספות בתקופות גדילה מונעות מתיחות יתר",
    "adolescentStudy": "יציבה בלימוד/משחק:",
    "adolescentStudyText": "הגדירו את מקום העבודה בגובה הנכון, קחו הפסקות קבועות",
    "adolescentStrength": "חיזוק:",
    "adolescentStrengthText": "תרגילי משקל גוף (פלאנקים, סקוואטים, לנג'ים) בונים בסיס חזק",
    "adolescentReturn": "מתי לחזור:",
    "adolescentReturnText": "צרו קשר אם הכאב מחמיר, עובר לאזור חדש או משפיע על פעילות יומיומית",
    "specificHomeAdvice": "המלצות טיפול ספציפיות בבית:",
    "do": "עשו:",
    "avoid": "הימנעו:",
    "recommendedExercises": "תרגילים מומלצים:",
    "whenToContactUs": "מתי ליצור איתנו קשר",
    "contactImmediatelyIf": "צרו קשר מיידית אם:",
    "contactImmediate1": "{{name}} מפתח/ת חום עם כאב במפרקים",
    "contactImmediate2": "{{name}} מסרב/ת להשתמש בגפה או לסמוך משקל עליה",
    "contactImmediate3": "כאב חזק שמחמיר למרות מנוחה",
    "contactImmediate4": "אתם מבחינים בנפיחות חדשה, אדמומיות או חום סביב מפרק",
    "contactImmediate5": "שינוי פתאומי באופן ההליכה או התנועה של {{name}}",
    "bookSoonerIf": "קבעו תור מוקדם יותר אם:",
    "bookSooner1": "הכאב לא משתפר לאחר שבועיים",
    "bookSooner2": "מתפתחים תסמינים חדשים",
    "bookSooner3": "יש לכם חששות כלשהם לגבי ההתקדמות של {{name}}",
    "otherwiseSeeAgain": "אחרת, נראה את {{name}} שוב לפי תוכנית הטיפול המתוארת למעלה.",
    "noteForParents": "הערה להורים",
    "parentsNote1": "אנו מבינים שראייה של ילדכם בכאב או באי נוחות יכולה להיות מדאיגה. חשוב לדעת שמצבו/ה של {{name}} נפוץ, ניתן לטיפול ומגיב לטיפול. ילדים עמידים להפליא, ועם התמיכה הנכונה רוב בעיות השלד והשרירים בילדות נפתרות היטב. אנו כאן כדי להדריך אתכם ואת {{name}} בכל הדרך.",
    "growingPainsTitle": "על כאבי גדילה:",
    "growingPainsNote": "כאבי גדילה הם חלק נורמלי מהילדות ואינם מצביעים על בעיה בעצמות או במפרקים של ילדכם. הם זמניים וייפתרו עם גדילת הילד. אמבטיה חמה לפני השינה ועיסוי עדין של האזור יכולים לעזור.",
    "parentsNote2": "אם יש לכם שאלות בין הביקורים, אנא אל תהססו לפנות אלינו. אין שאלה קטנה מדי כשמדובר בבריאות של ילדכם.",
    "nextSteps": "השלבים הבאים",
    "readyToBook": "מוכנים לקבוע את התור הבא של {{name}}?",
    "scanToBook": "סרקו לקביעת תור",
    "referralTitle": "מכירים משפחה נוספת שנוכל לעזור לה?",
    "referralText": "נשמח לעזור גם למשפחה ולחברים שלכם. אם אתם מכירים ילד שיכול להפיק תועלת מהטיפול שלנו, נשמח לקבל אותו.",
    "disclaimer": "דוח זה מיועד להורים/אפוטרופוסים של המטופל ונועד למטרות מידע. הוא אינו מחליף ייעוץ רפואי. אם יש לכם חששות לגבי בריאות ילדכם, אנא פנו לאיש מקצוע רפואי.",
    "reliefCare": "טיפול הקלה",
    "rehabilitation": "שיקום",
    "wellnessCare": "טיפול הרווחה"
  },
  "paediatricProgress": {
    "loading": "טוען נתוני התקדמות...",
    "title": "התקדמות מהביקור האחרון",
    "painLevels": "רמות כאב",
    "improving": "משתפר",
    "worsening": "מחמיר",
    "stable": "יציב",
    "resolved": "נפתר",
    "new": "חדש",
    "errorLoad": "לא ניתן היה לטעון נתוני התקדמות",
    "retry": "נסה שוב",
    "empty": "אין נתוני ביקור קודם להשוואה",
    "parentConcernChanges": "שינויים בדאגות ההורים",
    "ongoing": "נמשך",
    "treatmentResponseTitle": "תגובה לטיפול (דיווח הורה)",
    "developmentalMilestonesTitle": "אבני דרך התפתחותיות שהושגו",
    "exerciseCompliance": "עמידה בתרגילים",
    "outcomeMeasures": "מדדי תוצאה",
    "wellnessScore": "ציון ביצועי הגוף"
  },
  "paediatricReEval": {
    "title": "שאלון להורה / אפוטרופוס",
    "subtitle": "אנא ענו על השאלות הבאות בנוגע להתקדמות ילדכם מאז הביקור האחרון.",
    "loading": "טוען שאלון…",
    "errorLoad": "לא ניתן היה לטעון את השאלון. אנא נסו שוב.",
    "empty": "אין נתונים קודמים — התחילו לענות על השאלות למטה.",
    "retry": "נסו שוב",
    "savedDraft": "התשובות נשמרו",
    "saveError": "לא ניתן היה לשמור את התשובה. אנא נסו שוב.",
    "completed": "השאלון הושלם — תודה רבה!",
    "sectionParentConcerns": "חששות ההורה",
    "sectionDevelopment": "התפתחות",
    "sectionTreatmentResponse": "תגובה לטיפול",
    "devBanner": "בדיקת התפתחות — שאלות אלו עוזרות לנו לעקוב אחר אבני הדרך ההתפתחותיות של ילדכם.",
    "continue": "המשך →",
    "back": "← חזרה",
    "complete": "✓ סיום השאלון והמשך",
    "noPain": "ללא כאב",
    "worstPain": "כאב חמור ביותר",
    "q1": {
      "title": "ש1: איך הרגיש הילד שלכם מאז הביקור האחרון?",
      "options": {
        "Much better": "הרבה יותר טוב",
        "Slightly better": "מעט יותר טוב",
        "No change": "ללא שינוי",
        "Slightly worse": "מעט יותר גרוע",
        "Much worse": "הרבה יותר גרוע"
      }
    },
    "q2": {
      "title": "ש2: מהם החששות העיקריים שלכם היום?",
      "options": {
        "Pain is still present": "הכאב עדיין קיים",
        "Pain has moved to a different area": "הכאב עבר לאזור אחר",
        "New symptoms have appeared": "הופיעו תסמינים חדשים",
        "Child is not improving as expected": "הילד לא משתפר כמצופה",
        "Child is avoiding activities": "הילד נמנע מפעילויות",
        "Sleep is still disturbed": "השינה עדיין מופרעת",
        "Concerned about posture": "דאגה לגבי היציבה",
        "Concerned about development": "דאגה לגבי ההתפתחות",
        "Limping or favouring one side": "צולע או מעדיף צד אחד",
        "School/sports participation affected": "ההשתתפות בבית הספר/ספורט נפגעת",
        "No concerns — here for routine check": "ללא חששות — לבדיקת שגרה"
      }
    },
    "q3": {
      "title": "ש3: האם משהו השתנה מאז הביקור האחרון?",
      "options": {
        "Started a new sport or activity": "התחיל ספורט או פעילות חדשה",
        "Had a fall or injury": "היה נפילה או פציעה",
        "Been unwell (illness, fever)": "היה חולה (מחלה, חום)",
        "Growth spurt noticed": "נצפה זינוק גדילה",
        "Started or stopped medication": "התחיל או הפסיק תרופות",
        "Changed shoes or school bag": "החליף נעליים או תיק בית ספר",
        "Nothing has changed": "שום דבר לא השתנה"
      }
    },
    "q4": {
      "title": "ש4: איך הילד מתמודד רגשית?",
      "options": {
        "Happy and active as usual": "שמח ופעיל כרגיל",
        "A bit frustrated by the limitation": "מעט מתוסכל מההגבלה",
        "Anxious about the condition": "חרד לגבי המצב",
        "Withdrawn or less active than usual": "מסתגר או פחות פעיל",
        "No noticeable change": "אין שינוי ניכר"
      }
    },
    "q5": {
      "title": "ש5: האם הילד ביצע את תרגילי הבית / ההמלצות?",
      "options": {
        "Yes, consistently": "כן, באופן עקבי",
        "Yes, but not regularly": "כן, אבל לא באופן קבוע",
        "Sometimes": "לפעמים",
        "Rarely": "לעיתים רחוקות",
        "Not at all": "בכלל לא",
        "Exercises were not prescribed": "לא נרשמו תרגילים"
      }
    },
    "q6": {
      "title": "ש6: בסולם של 0-10, איך תדרגו את הכאב של הילד עכשיו?"
    },
    "q7": {
      "title": "ש7: מאז הביקור האחרון, האם שמתם לב לשינויים בתנועת הילד?",
      "options": {
        "Moving more freely": "זז בחופשיות רבה יותר",
        "Started crawling / walking / running (milestone achieved)": "התחיל לזחול / ללכת / לרוץ (אבן דרך)",
        "Seems less coordinated than before": "נראה פחות מתואם מבעבר",
        "Head control has improved": "שליטת הראש השתפרה",
        "Still favouring one side": "עדיין מעדיף צד אחד",
        "No change noticed": "לא נצפה שינוי"
      }
    },
    "q8": {
      "title": "ש8: האם יש חששות לגבי האכלה?",
      "options": {
        "Feeding well from both sides": "אוכל טוב משני הצדדים",
        "Still prefers one side": "עדיין מעדיף צד אחד",
        "Difficulty latching or feeding": "קושי באחיזה או באכילה",
        "No concerns": "ללא חששות"
      }
    },
    "q9": {
      "title": "ש9: איך הילד ישן?",
      "options": {
        "Sleeping well through the night": "ישן טוב כל הלילה",
        "Waking due to discomfort": "מתעורר בגלל אי נוחות",
        "Sleeping in an unusual position": "ישן בתנוחה לא רגילה",
        "Sleep has improved since last visit": "השינה השתפרה מאז הביקור האחרון",
        "No change": "ללא שינוי"
      }
    },
    "q10": {
      "title": "ש10: אילו טיפולים הילד קיבל מאז הביקור האחרון?",
      "options": {
        "Chiropractic adjustments": "התאמות כירופרקטיות",
        "Soft tissue therapy": "טיפול ברקמות רכות",
        "Exercise therapy": "טיפול בפעילות גופנית",
        "Home exercises only": "תרגילי בית בלבד",
        "Other healthcare provider treatment": "טיפול אצל מטפל אחר",
        "No treatment received": "לא התקבל טיפול"
      }
    },
    "q11": {
      "title": "ש11: איך הילד הגיב לטיפול?",
      "options": {
        "Pain reduced after treatment": "הכאב פחת לאחר הטיפול",
        "More mobile after treatment": "יותר גמיש לאחר הטיפול",
        "Temporary soreness after treatment (normal)": "כאב זמני לאחר הטיפול (תקין)",
        "No noticeable effect": "אין השפעה ניכרת",
        "Symptoms worsened after treatment (important to note)": "התסמינים החמירו לאחר הטיפול (חשוב לציין)"
      }
    }
  },
  "outcomeMeasures": {
    "title": "מדדי תוצאה",
    "recommended": "מומלץ על בסיס אזורי תלונה",
    "vasAlreadyCaptured": "דירוג כאב VAS כבר נרשם בסעיף התלונות.",
    "skipMeasures": "דלג על מדדי תוצאה",
    "measureOf": "מדד {{current}} מתוך {{total}}",
    "allComplete": "כל המדדים המוצעים הושלמו",
    "saveAndContinue": "שמור והמשך",
    "ndi": "מדד נכות צוואר",
    "odi": "מדד נכות Oswestry",
    "dash": "DASH (מוגבלויות יד, כתף, זרוע)",
    "lefs": "סולם תפקוד גפיים תחתונות",
    "phq9": "שאלון בריאות המטופל-9",
    "gad7": "הפרעת חרדה כללית-7",
    "startBack": "כלי סינון STarT Back",
    "tsk11": "סולם קינזיופוביה של טמפה-11",
    "severity": {
      "noDisability": "ללא מוגבלות",
      "mild": "קל",
      "moderate": "בינוני",
      "severe": "חמור",
      "fairlySevere": "חמור למדי",
      "verySevere": "חמור מאוד",
      "complete": "מוגבלות מלאה"
    }
  },
  "ddx": {
    "title": "סקירת אבחנה מבדלת",
    "confidence": {
      "strong": "חזקה",
      "probable": "סבירה",
      "possible": "אפשרית",
      "lessLikely": "פחות סבירה",
      "unlikely": "לא סבירה"
    },
    "status": {
      "suggested": "מוצע",
      "confirmed": "מאושר",
      "overridden": "נדחה ידנית",
      "rejected": "נדחה",
      "clinicianAdded": "נוסף על ידי רופא",
      "notSelected": "לא נבחר"
    },
    "confirmBtn": "אשר",
    "rejectBtn": "דחה",
    "overrideBtn": "דריסה",
    "showEvidence": "הצג ראיות",
    "hideEvidence": "הסתר ראיות",
    "redFlagStatus": "סטטוס דגלים אדומים",
    "acknowledged": "אושר",
    "allRedFlagsRequired": "יש לאשר את כל הדגלים האדומים לפני הסיום",
    "aiSecondOpinion": "אופציונלי: חוות דעת שנייה של AI",
    "analyzing": "מנתח...",
    "getAiOpinion": "קבל חוות דעת AI",
    "refreshAiOpinion": "רענן חוות דעת AI",
    "noAiSuggestions": "אין הצעות נוספות מ-AI",
    "ruleBasedComplete": "ניתוח מבוסס כללים הושלם",
    "clusterAnalysis": "ניתוח אשכולות",
    "conditions": "מצבים",
    "commonFindings": "ממצאים נפוצים",
    "systemicAlerts": "התראות דפוסים מערכתיים",
    "finalizeAssessment": "סיים הערכה",
    "finalizing": "מסיים...",
    "workingHypotheses": "השערות עבודה",
    "confirmed": "מאושר",
    "confidenceLabel": "ביטחון",
    "acknowledgeAndConfirm": "אשר וקבל",
    "supportingEvidence": "ראיות תומכות",
    "addConditionManually": "הוסף מצב ידנית",
    "searchAndAdd": "חפש והוסף מצב",
    "searchPlaceholder": "חיפוש לפי שם מצב, קוד ICD, או אזור גוף...",
    "noMatchingConditions": "לא נמצאו מצבים תואמים",
    "typeToSearch": "הקלד לפחות 2 תווים לחיפוש",
    "confirmAtLeastOne": "אשר לפחות השערת עבודה אחת לפני הסיום.",
    "crossComplaintAlerts": "התראות דפוסים חוצי-תלונות",
    "clinicalNote": "הערה קלינית",
    "referTo": "הפנה אל",
    "additionalTests": "בדיקות נוספות",
    "matchedCriteria": "קריטריונים תואמים",
    "selectTop3": "בחר 3 עליונים",
    "selectBtn": "בחר",
    "confirmedCount": "{{confirmed}} / {{total}} מאושרים",
    "emergency": "חירום",
    "medicalEmergency": "חירום רפואי",
    "emergencyAction": "חירום רפואי — דורש פעולה מיידית",
    "emergencyFlags": "דגלי חירום רפואי",
    "critical": "קריטי",
    "loadingReview": "טוען סקירת DDx...",
    "noData": "אין נתונים זמינים.",
    "selectHint": "לחץ על <strong>בחר</strong> לאישור השערות עבודה. רק מצבים מאושרים נכללים בתוכנית הטיפול.",
    "hypothesisCount_one": "השערה {{count}}",
    "hypothesisCount_other": "{{count}} השערות",
    "skipAiSuggestions": "דלג על הצעות AI",
    "acceptBtn": "✓ קבל",
    "accepted": "✓ התקבל",
    "aiSuggestion": "הצעת AI",
    "aiDismissed": "הצעות AI נדחו. ממשיכים עם DDx ידנית בלבד.",
    "aiComprehensive": "אין הצעות נוספות מ-AI. הניתוח מבוסס הכללים נראה מקיף.",
    "aiClinicalNotes": "הערות קליניות AI",
    "aiDescription": "ניתוח מבוסס כללים הושלם. רוצה חוות דעת שנייה של AI?",
    "reasoning": "נימוק:",
    "keyFindings": "ממצאים מרכזיים:",
    "recommendedTests": "בדיקות מומלצות לאישור/שלילה:",
    "hideDetails": "הסתר פרטים",
    "showDetails": "הצג פרטים",
    "regions": {
      "lumbar": "מותני (גב תחתון)",
      "cervical": "צווארי (צוואר)",
      "thoracic": "חזי (גב אמצעי)",
      "shoulder": "כתף",
      "shoulder_left": "כתף שמאל",
      "shoulder_right": "כתף ימין",
      "knee": "ברך",
      "knee_left": "ברך שמאל",
      "knee_right": "ברך ימין",
      "hip": "ירך",
      "hip_left": "ירך שמאל",
      "hip_right": "ירך ימין",
      "elbow": "מרפק",
      "elbow_left": "מרפק שמאל",
      "elbow_right": "מרפק ימין",
      "wrist_hand": "שורש כף יד/כף יד",
      "wrist_hand_left": "שורש כף יד/כף יד שמאל",
      "wrist_hand_right": "שורש כף יד/כף יד ימין",
      "ankle_foot": "קרסול/כף רגל",
      "ankle_foot_left": "קרסול/כף רגל שמאל",
      "ankle_foot_right": "קרסול/כף רגל ימין",
      "tmj": "מפרק לסת"
    },
    "card": {
      "regions": "אזורים:"
    },
    "acknowledgeAndDismiss": "אישור ודחייה",
    "dismissed": "נדחה",
    "restoreDismissed": "שחזור השערה",
    "dismissReasonLabel": "סיבת הדחייה (חובה, לפחות 5 תווים)",
    "dismissReasonPlaceholder": "למשל: אין הרדמת אוכף, תפקוד שלפוחית תקין, טווח תנועה מלא ללא כאב",
    "dismissConfirm": "דחייה עם סיבה",
    "dismissCancel": "ביטול",
    "escalateForEmergency": "הסלמה להערכת חירום",
    "escalateExplainer": "רק מתג זה מכניס ניסוח הפניית חירום למכתבי רופאים/ביטוח.",
    "escalateAction": "הסלמה",
    "escalationActive": "הסלמה פעילה",
    "acknowledgeFlag": "אישור ודחיית דגל",
    "confirmDifferential": "אישור אבחנה מבדלת",
    "confirming": "מאשר...",
    "confirmedToast": "האבחנה המבדלת אושרה — בדקו את תוכנית הטיפול. הדוח מונפק בלחיצה על סיום."
  },
  "careJourney": {
    "painRelief": {
      "title": "טיפול הקלה",
      "duration": "2–6 שבועות",
      "description": "העדיפות הראשונה היא הפחתת הכאב והרגעת הרקמות. אנו מתמקדים בטיפול עדין, ביקורים קצרים ואסטרטגיות ביתיות פשוטות כדי שתוכלו לישון, לנוע ולעבוד עם פחות אי נוחות."
    },
    "rehabilitation": {
      "title": "שיקום",
      "duration": "6 שבועות – 6 חודשים",
      "description": "לאחר שהכאב נשלט, אנו בונים מחדש כוח, ניידות ואיכות תנועה. הטיפולים הופכים לתכופים פחות ואתם מבצעים תרגילים פעילים יותר — זה השלב שמבסס את השיפור."
    },
    "maintenance": {
      "title": "טיפול הרווחה",
      "duration": "מתמשך",
      "description": "בדיקות תקופתיות שומרות על השיפורים שהשגתם. אנו בודקים את היציבה, התנועה וסימני אזהרה מוקדמים, ומתאימים לפי הצורך כדי שבעיות קטנות לא יהפכו לגדולות."
    }
  },
  "managementPlan": {
    "title": "תוכנית טיפול",
    "panel": {
      "phases": {
        "title": "שלבי הטיפול",
        "phaseLabel": "שלב"
      },
      "frequency": {
        "title": "תדירות הטיפול",
        "empty": "אין עדיין בלוקים של תדירות. בחר ערכה מוגדרת מראש למעלה או לחץ \"הוסף בלוק\" כדי להתחיל."
      }
    },
    "preset": {
      "rowLabel": "ערכה"
    },
    "block": {
      "add": "הוסף בלוק",
      "delete": "מחק",
      "labelAria": "תווית בלוק",
      "frequencyPlaceholder": "למשל 3x/שבוע",
      "durationPlaceholder": "שבועות",
      "visitsPlaceholder": "ביקורים",
      "deleteMaintenanceConfirm": "להסיר את בלוק התחזוקה? למטופל לא יהיה בלוק טיפול מתמשך לאחר השלבים הפעילים."
    },
    "maintenance": {
      "label": "תחזוקה"
    },
    "generatePlan": "צור תוכנית",
    "regeneratePlan": "צור מחדש",
    "generating": "יוצר...",
    "completeDdxFirst": "השלם תחילה את שלב סקירת DDx",
    "needConfirmedHypothesis": "תוכנית טיפול דורשת לפחות השערת עבודה מאושרת אחת",
    "noPlanYet": "טרם נוצרה תוכנית טיפול. לחץ \"צור תוכנית\" ליצירת תוכנית מקיפה על בסיס מצבים מאושרים.",
    "confirmedConditions": "מצבים מאושרים",
    "expectedDuration": "משך צפוי כולל",
    "treatmentPhases": "שלבי טיפול",
    "precautions": "אמצעי זהירות ואזהרות",
    "referralCriteria": "קריטריונים להפניה",
    "supplements": "המלצות תוספי תזונה",
    "supplementsClinicianOnly": "לעיון הקלינאי בלבד, לא לפלט למטופל",
    "evidenceBase": "בסיס ראיות",
    "phase": "שלב {{num}}:",
    "duration": "משך:",
    "frequency": "תדירות:",
    "techniques": "טכניקות",
    "goals": "מטרות",
    "condition": "מצב",
    "criteria": "קריטריונים",
    "urgency": "דחיפות",
    "routine": "שגרתי",
    "urgent": "דחוף",
    "emergent": "חירום",
    "every2weeks": "כל שבועיים",
    "every3weeks": "כל 3 שבועות",
    "every4weeks": "כל 4 שבועות (חודשי)",
    "every6weeks": "כל 6 שבועות",
    "ongoingWellness": "טיפול בריאותי מתמשך",
    "selfLimiting": "מצב המגביל את עצמו",
    "expectedTimeline": "לוח זמנים צפוי",
    "evidence": {
      "levelA": "רמה A — חזקה",
      "levelB": "רמה B — בינונית",
      "levelC": "רמה C — מוגבלת"
    },
    "loadingSupplements": "טוען תוספים...",
    "regenerate": "צור מחדש",
    "generate": "צור תוכנית",
    "requiresHypothesis": "תוכנית טיפול דורשת לפחות השערת עבודה מאושרת אחת.",
    "goToDdx": "← עבור לסקירת DDx",
    "addressesConditions": "תוכנית הטיפול מטפלת ב-{{count}} מצבים",
    "acrossRegions": "ב-{{count}} אזורים",
    "treatmentGoals": "יעדי טיפול המטופל",
    "goalsSelected": "{{count}} יעדים נבחרו — תוכנית הטיפול תותאם ליעדים אלו.",
    "visitSchedule": "לוח זמנים לביקורים",
    "phase1": "בלוק 1",
    "phase2": "בלוק 2",
    "phase3": "בלוק 3",
    "understanding": "הבנת המצבים שלך",
    "treatmentJourney": "מסע הטיפול שלך",
    "acutePhase": "טיפול הקלה",
    "rehabPhase": "שיקום",
    "maintenancePhase": "תחזוקה",
    "visitFrequency": "תדירות ביקורים מומלצת",
    "homeExercises": "מה אפשר לעשות בבית",
    "paediatricGuidance": "הנחיות ילדים",
    "exerciseProgrammePdf": "PDF תוכנית תרגילים",
    "generated": "נוצר",
    "infantGoals": "יעדי טיפול לתינוק שלך",
    "treatmentsConcurrent": "הטיפולים מתבצעים במקביל",
    "clinicianOverride": "התאמת רופא",
    "scheduleDescription": "פרוטוקולי הטיפול נבדקו מול הראיות הקליניות העדכניות ביותר. התאם את לוח הזמנים למטה לפי הצורך.",
    "visitsPerWeek": "ביקורים/שבוע",
    "for": "למשך",
    "weeks": "שבועות",
    "visits": "ביקורים",
    "phase3Ongoing": "תחזוקה",
    "reExamSchedule": "לוח בדיקות חוזרות",
    "reExamsAtWeek": "בדיקות חוזרות בשבוע",
    "addReExamWeek": "הוסף שבוע בדיקה חוזרת",
    "removeLastReExam": "הסר בדיקה חוזרת אחרונה",
    "scheduleSummary": "בלוקים 1+2: ~{{totalVisits}} ביקורים ב-~{{totalWeeks}} שבועות + תחזוקה: כל {{maintenanceWeeks}} שבועות (שוטף)",
    "resetToDefaults": "איפוס לברירת מחדל",
    "whatDoesThisMean": "מה זה אומר?",
    "whatIsThis": "מה זה?",
    "howDoesItHappen": "איך זה קורה?",
    "whatCanBeDone": "מה אפשר לעשות?",
    "whatToExpect": "מה לצפות",
    "whenToWorry": "מתי לדאוג",
    "do": "מומלץ",
    "avoid": "להימנע",
    "contraindications": "התוויות נגד",
    "recommendedApproach": "גישה מומלצת",
    "clinicServices": "שירותי מרפאה",
    "noSupplementsYet": "טרם נוצרו המלצות לתוספי תזונה. הן נוצרות אוטומטית בעת יצירת תוכנית הטיפול.",
    "grade": "דרגה",
    "dosage": "מינון",
    "timing": "תזמון",
    "highSeverityWarning": "זוהתה אינטראקציה בחומרה גבוהה — שקול להשבית תוסף זה",
    "disableSupplement": "השבת תוסף",
    "enableSupplement": "הפעל תוסף",
    "active": "פעילים",
    "total": "סה\"כ",
    "citations": "ציטוטים",
    "effect": "אפקט",
    "evidenceLevelsDescription": "רמות ראיות: A = מחקרים אקראיים מבוקרים/מטא-אנליזות באיכות גבוהה, B = ראיות באיכות בינונית, C = קונצנזוס מומחים/סדרות מקרים",
    "failedToGenerate": "יצירת התוכנית נכשלה",
    "exercisePdfError": "שגיאת PDF תרגילים",
    "downloadFailed": "ההורדה נכשלה",
    "goalLabels": {
      "pain_relief": "הקלת כאב",
      "return_to_sport": "חזרה לספורט/פעילות",
      "improve_posture": "שיפור יציבה",
      "prevent_recurrence": "סיוע בהפחתת הסיכון להישנות",
      "improve_mobility": "שיפור ניידות/גמישות",
      "manage_chronic": "ניהול מצב כרוני",
      "pre_post_surgical": "שיקום לפני/אחרי ניתוח",
      "general_wellness": "בריאות כללית",
      "symptom_resolution": "פתרון תסמינים",
      "improve_movement": "שיפור תנועה וסימטריה",
      "support_development": "תמיכה באבני דרך התפתחותיות",
      "feeding_comfort": "שיפור נוחות האכלה",
      "sleep_improvement": "שיפור איכות שינה",
      "parent_confidence": "בניית ביטחון הורי",
      "head_shape": "שיפור צורת הראש",
      "prevent_secondary": "מניעת בעיות משניות"
    },
    "regions": {
      "lumbar": "מותני (גב תחתון)",
      "cervical": "צווארי (צוואר)",
      "thoracic": "חזי (גב אמצעי)",
      "shoulder": "כתף",
      "knee": "ברך",
      "hip": "ירך",
      "elbow": "מרפק",
      "wrist": "שורש כף יד/כף יד",
      "ankle": "קרסול/כף רגל",
      "general": "כללי"
    },
    "visitWarning": {
      "title": "מספר הביקורים נמוך מהטווח האופייני למסלול הטיפולי",
      "body": "מספר הביקורים המתוכנן נמוך מהטווח האופייני למסלול הטיפולי עבור דרגת חומרה זו. בחנו האם מספר הביקורים הנמוך יותר הוא מכוון (תגובה מהירה צפויה, העדפת המטופל, תמונה קלינית קלה) או האם תוכנית קצרה להערכה מחודשת תהיה מתאימה.",
      "severity": {
        "mild": "קל",
        "moderate": "בינוני",
        "moderateSevere": "בינוני-חמור",
        "severe": "חמור"
      }
    },
    "severityTier": {
      "mildModerate": "קל-בינוני",
      "moderate": "בינוני",
      "moderateSevere": "בינוני-חמור",
      "moderateHigh": "בינוני-גבוה",
      "high": "גבוה"
    },
    "moderateExplanation": "התסמינים שלך מצביעים על רמת השפעה כללית בינונית, מכיוון שמעורב יותר מאזור אחד, וציון הכאב הגבוה ביותר שדיווחת עליו הוא 6/10. אין בכך כדי לומר שנמצא משהו מסוכן, אך זה עוזר לנו לתכנן את הטיפול ולעקוב אחר ההתקדמות שלך.",
    "reexamPoints": {
      "title": "בדיקות חוזרות",
      "add": "הוספת בדיקה חוזרת",
      "empty": "לא תוזמנו בדיקות חוזרות. הוסיפו אחת כדי לעגן בדיקת התקדמות רשמית לביקור מתוכנן.",
      "visitOption": "ביקור {{n}} (שבוע {{w}})",
      "missingVisit": "ביקור {{n}} (אינו מתוכנן עוד)",
      "invalidWarning": "ביקור זה אינו קיים עוד — לא ייכלל בדוח עד לתיקון.",
      "remove": "הסרה"
    },
    "genericTemplate": "תבנית כללית",
    "genericTemplateHint": "אין פרוטוקול ייעודי למצב זה; זוהי התבנית הכללית בת 3 השלבים."
  },
  "report": {
    "title": "דוח קליני",
    "generate": "יצירת דוח",
    "regenerate": "יצירה מחדש",
    "format": "פורמט דוח",
    "compact": "מקוצר",
    "comprehensive": "מפורט",
    "selectLanguage": "שפת הדוח",
    "selectSections": "סעיפים לכלול",
    "printReport": "הדפסת דוח",
    "downloadPdf": "הורדת PDF",
    "generatedOn": "נוצר בתאריך",
    "disclaimer": "דוח זה מכיל השערות עבודה לשיקול קליני בלבד. הוא אינו מהווה אבחנה סופית.",
    "includeLetterhead": "כלול נייר מכתבים של המרפאה",
    "enhanceWithAi": "שפר עם AI",
    "selectAtLeastOne": "בחר לפחות סעיף אחד",
    "aiSummary": "סיכום משופר AI (אופציונלי)",
    "dismiss": "סגור",
    "keyPoints": "נקודות מפתח",
    "nextSteps": "צעדים הבאים מומלצים",
    "clinicalReport": "דוח הערכה קלינית",
    "compactReport": "דוח מקוצר",
    "comprehensiveReport": "דוח מפורט",
    "bookAppointment": "קבע את התור הבא שלך",
    "callUs": "התקשר:",
    "emailUs": "אימייל:",
    "visitUs": "בקר אותנו:",
    "openingHours": "שעות פתיחה:",
    "followInstagram": "עקבו אחרינו באינסטגרם:",
    "scanToBook": "סרוק לקביעת התור הבא שלך",
    "confidential": "חסוי",
    "was": "היה",
    "now": "עכשיו",
    "before": "לפני",
    "better": "יותר טוב",
    "improvement": "שיפור",
    "outcomeMeasureDeltas": "שינויים במדדי תוצאה",
    "outcomeMeasureChanges": "שינויים במדדי תוצאה",
    "measure": "מדד",
    "change": "שינוי",
    "significance": "משמעות",
    "whyOngoingCare": "למה טיפול מתמשך חשוב",
    "painRelief": "הקלת כאב",
    "rehabilitation": "שיקום",
    "maintenance": "תחזוקה",
    "peakPerformance": "ביצועים מרביים",
    "emailReport": "שלח דוח למטופל באימייל",
    "emailInstructions": "הזן את כתובת האימייל של המטופל לשליחת עותק של דוח זה",
    "patientEmailOverride": "אימייל מטופל (החלפה אופציונלית)",
    "sendReport": "שלח דוח",
    "sending": "שולח...",
    "sections": {
      "patient_info": "פרטי המטופל",
      "chief_complaints": "תלונות עיקריות",
      "medical_history": "היסטוריה רפואית",
      "examination_findings": "ממצאי בדיקה",
      "imaging_results": "תוצאות הדמיה",
      "diagnosis": "אבחנה (DDx)",
      "treatment_plan": "תוכנית טיפול",
      "wellness_score": "ציון ביצועי הגוף",
      "red_flags": "דגלים אדומים",
      "referrals": "הפניות",
      "supplement_plan": "המלצות תוספי תזונה"
    },
    "yourCarePathway": "הדרך להתקדמות",
    "phase1PainRelief": "1. טיפול הקלה",
    "phase1Desc": "שלב החלמה — משחרר אתכם מכאב",
    "phase2Rehab": "2. שיקום",
    "phase2Desc": "שלב שיפור — בונה את החוסן שלכם",
    "phase3Wellness": "3. טיפול הרווחה",
    "phase3Desc": "שלב אופטימיזציה — שומר עליכם בשיא",
    "didYouKnow": "הידעתם?",
    "didYouKnowText": "בדיקות תקופות עוזרות לנו לעקוב אחר ההתקדמות שלכם, לזהות שינויים בתנועה או בתפקוד בשלב מוקדם, ולתמוך בניהול העצמי שלכם. למטופלים רבים, טיפול מתמשך עוזר לשמור על פעילות ולהפחית הסיכוי להתלקחויות.",
    "knowSomeone": "מכיר/ה מישהו שיכול להרוויח?",
    "knowSomeoneText": "נשמח לעזור גם למשפחה ולחברים שלך. אם את/ה מכיר/ה מישהו שיכול להרוויח מהטיפול שלנו, נשמח לקבל אותו.",
    "outOf100": "מתוך 100",
    "zone": "אזור",
    "treatmentGoals": "מטרות הטיפול שלכם:",
    "whenToContact": "מתי ליצור קשר",
    "dearGuardianOf": "הורה/אפוטרופוס של",
    "dearPatient": "יקר/ה",
    "thankYouBringing": "תודה שהבאתם את {name} ל{clinic}. להלן סיכום הממצאים שלנו ותוכנית הטיפול המומלצת.",
    "ongoingCareIntro": "כשם שאתם מבקרים אצל רופא השיניים כל 6 חודשים לשמירה על בריאות השיניים, כך עמוד השדרה ומערכת השלד-שריר שלכם נהנים מבדיקות תקופתיות. ביקורים אלו עוזרים לנו לזהות בעיות קטנות לפני שהן הופכות לגדולות.",
    "evidenceCareParagraph": "כאבי גב וצוואר יכולים להשתפר, אך התסמינים עלולים לפעמים לחזור — במיוחד כאשר לא מטפלים בגורמים כמו יציבה בעבודה, מתח, חולשת שרירים, נוקשות, עומס אימונים או גורמים הקשורים לאורח החיים. מחקרים תומכים בטיפול מנואלי, כולל מניפולציה בעמוד השדרה, כאחת האפשרויות לטיפול בכאב גב תחתון, כאשר הוא משולב עם פעילות גופנית, שיקום, הדרכה וניהול עצמי. עבור מטופלים נבחרים עם כאב גב תחתון חוזר או מתמשך, שמגיבים היטב לטיפול כירופרקטי ראשוני, נמצא כי טיפול משמר יכול להפחית את מספר הימים עם כאב גב טורדני במשך 12 חודשים, בהשוואה לטיפול רק כאשר התסמינים חוזרים.",
    "evidenceCitation": "מבוסס על: NICE Guideline NG59; Eklund et al. (2018) Nordic Maintenance Care RCT; Senna & Machaly (2011) Spine; Cochrane Review CD008112 (Rubinstein et al.).",
    "encourageWellness": "אנו ממליצים על בדיקות בריאות סדירות גם לאחר שהתסמינים חלפו. בריאות מערכת השלד-שריר שלכם היא מסע מתמשך, ואנחנו כאן לתמוך בכם בכל צעד.",
    "versionHistory": "היסטוריית תיקונים",
    "supersededBanner": "את/ה צופה בגרסה שהוחלפה. היא לקריאה בלבד.",
    "versionLabel": "גרסה",
    "versionCurrent": "נוכחית",
    "versionSuperseded": "הוחלפה",
    "notReadyTitle": "הדוח הזה עדיין לא מוכן",
    "notReadyBody": "בהערכה עדיין אין מספיק נתונים שנרשמו כדי להפיק דוח למטופל. השלימו את השלבים הנותרים ופתחו את הדוח שוב."
  },
  "soap": {
    "title": "רשומת SOAP",
    "printView": "רשומת SOAP — תצוגת הדפסה",
    "loading": "טוען רשומת SOAP...",
    "autoGenerate": "יצירה אוטומטית",
    "aiPolish": "שיפור AI",
    "aiPolishing": "שיפור AI...",
    "backToEditor": "חזרה לעורך",
    "saveNote": "שמור רשומת SOAP",
    "saving": "שומר...",
    "savedSuccess": "רשומת SOAP נשמרה בהצלחה.",
    "autoGenerated": "רשומה נוצרה אוטומטית מנתוני ההערכה.",
    "subjective": "סובייקטיבי",
    "objective": "אובייקטיבי (ממצאים והשערות עבודה)",
    "assessment": "פעולה / טיפול שניתן",
    "plan": "תוכנית",
    "subjectivePlaceholder": "תסמינים, היסטוריה ותלונות שדווחו על ידי המטופל...",
    "objectivePlaceholder": "ממצאי בדיקה, השערות עבודה DDx, ציון BPS...",
    "assessmentPlaceholder": "לדוגמה: CMT C4-5 סיבוב ימני, ניוד דרגה IV L4-5...",
    "planPlaceholder": "תוכנית טיפול, מעקב, הפניות, הדרכת מטופל...",
    "formatting": "עיצוב:",
    "errors": {
      "generateFailed": "שגיאה ביצירת רשומת SOAP",
      "saveFailed": "שגיאה בשמירת רשומת SOAP"
    }
  },
  "settings": {
    "title": "הגדרות מרפאה",
    "manageDesc": "ניהול מיתוג ומידע של המרפאה",
    "viewDesc": "צפייה במידע המרפאה",
    "clinicInfo": "מידע על המרפאה",
    "clinicName": "שם המרפאה",
    "phone": "טלפון",
    "email": "אימייל",
    "website": "אתר אינטרנט",
    "address": "כתובת",
    "instagram": "חשבון אינסטגרם",
    "openingHours": "שעות פתיחה",
    "clinicLogo": "לוגו המרפאה",
    "logoDesc": "העלה את לוגו המרפאה. יופיע בכותרת האפליקציה, דף ההתחברות והדוחות. פורמטים: PNG, JPG, SVG. מקס 2MB.",
    "uploading": "מעלה…",
    "uploadLogo": "העלאת לוגו",
    "removeLogo": "הסר לוגו",
    "branding": "מיתוג",
    "primaryColor": "צבע ראשי",
    "usedInHeaders": "משמש בכותרות דוחות",
    "reportFooter": "טקסט תחתית דוח",
    "qrCodeUrl": "כתובת קוד QR (לדוחות)",
    "qrCodeDesc": "הדבק קישור להזמנת תור, דף אינסטגרם או קישור Google Maps. קוד QR יופיע בדוחות מטופלים.",
    "saveClinicInfo": "שמור מידע מרפאה",
    "aiConfig": "הגדרת AI",
    "aiConfigDesc": "הגדר API חיצוני של AI לניתוח קליני כמו חוות דעת שנייה DDx, יצירת רשומות SOAP וניתוח הדמיה.",
    "aiProvider": "ספק AI",
    "model": "מודל",
    "enterModel": "הזן שם מודל",
    "apiKey": "מפתח API",
    "currentKeyMasked": "מפתח נוכחי: [מוסתר] — השאר ריק לשמירה",
    "apiEndpoint": "נקודת קצה API",
    "monthlyBudget": "מגבלת תקציב חודשית (אופציונלי)",
    "noLimit": "ללא מגבלה",
    "perMonth": "/ חודש (מידע)",
    "saveAiConfig": "שמור הגדרת AI",
    "testConnection": "בדוק חיבור",
    "testing": "בודק…",
    "emailConfig": "הגדרת אימייל (SMTP)",
    "emailConfigDesc": "הגדר SMTP לשליחת דוחות מטופלים באימייל ישירות מהפלטפורמה. סיסמת SMTP מאוחסנת מוצפנת.",
    "enableEmail": "אפשר שליחת אימייל",
    "smtpHost": "שרת SMTP",
    "smtpPort": "פורט SMTP",
    "smtpPortWarning465": "פורט 465 עלול להיחסם על ידי חלק מספקי האחסון. אם המיילים נכשלים, עברו לפורט 587 (STARTTLS).",
    "smtpUser": "שם משתמש SMTP",
    "smtpPassword": "סיסמת SMTP",
    "smtpFrom": "כתובת אימייל שולח",
    "saveSmtpConfig": "שמור הגדרת SMTP",
    "tabClinicSettings": "הגדרות מרפאה",
    "tabTreatmentProtocols": "פרוטוקולי טיפול",
    "navIdentity": "זהות המרפאה",
    "navTeam": "הצוות שלכם",
    "navModalities": "שיטות טיפול",
    "navTools": "כלי הערכה",
    "navPathway": "מסלול טיפולי",
    "navReports": "דוחות",
    "navChecker": "בדיקת תסמינים",
    "navIntegrations": "אינטגרציות",
    "navType": "סוג מרפאה",
    "navBilling": "חיוב",
    "whatsappNumber": "מספר WhatsApp",
    "googleMapsLink": "קישור Google Maps",
    "facebook": "Facebook",
    "linkedin": "LinkedIn",
    "regionalSettings": "הגדרות אזוריות",
    "dateFormat": "תבנית תאריך",
    "dateFmtEU": "DD/MM/YYYY (אירופה/קפריסין)",
    "dateFmtUS": "MM/DD/YYYY (ארה\"ב)",
    "dateFmtISO": "YYYY-MM-DD (ISO)",
    "measurementSystem": "מערכת מדידה",
    "measureMetric": "מטרי (ס\"מ, ק\"ג)",
    "measureImperial": "אימפריאלי (אינץ', ליברות)",
    "customNextSteps": "צעדים הבאים מותאמים",
    "customNextStepsDesc": "התאימו את מדור \"הצעדים הבאים\" בדוחות מטופלים עם הודעה ותמונה משלכם.",
    "customMessage": "הודעה מותאמת",
    "generateWithAi": "יצירה עם AI",
    "nextStepsImage": "תמונת צעדים הבאים (אופציונלי)",
    "nextStepsImageDesc": "העלו תמונה להצגה במדור הצעדים הבאים בדוחות. מקסימום 1MB.",
    "removeImage": "הסר תמונה",
    "reportContent": "תוכן דוח",
    "reportContentDesc": "התאימו את הטקסט המופיע במדורי דוח המטופל.",
    "aboutOurTeam": "על הצוות שלנו",
    "treatmentApproach": "גישה טיפולית",
    "maintenanceWellnessMsg": "הודעת תחזוקה / בריאות",
    "yourTeam": "הצוות שלכם",
    "addMember": "+ הוסף חבר צוות",
    "teamDesc": "חברי צוות אלה מופיעים בדוח המטופל תחת \"צוות הטיפול שלכם\". המטפל הראשי חותם על דוחות.",
    "fullName": "שם מלא *",
    "roleTitle": "תפקיד / כותרת במרפאה *",
    "professionalCredential": "הסמכה מקצועית",
    "selectCredential": "— בחרו הסמכה —",
    "displayOnReports": "הצגה בדוחות",
    "displayPrefNameCred": "שם (הסמכה) — ברירת מחדל",
    "displayPrefNameOnly": "שם בלבד",
    "displayPrefCustom": "מותאם — טקסט חופשי",
    "customTitlePlaceholder": "בדיוק כפי שתרצו שהשם שלכם יופיע בדוחות",
    "preview": "תצוגה מקדימה:",
    "shortBio": "ביוגרפיה קצרה",
    "shortBioPlaceholder": "ביוגרפיה מקצועית קצרה בדוחות מטופלים (מקסימום 600 תווים)",
    "leadClinician": "מטפל ראשי / בעלים",
    "leadClinicianNote": "(חותם על דוחות, רק אחד למרפאה)",
    "lead": "ראשי",
    "noTeamMembers": "לא הוגדרו חברי צוות. לחצו \"הוסף חבר צוות\" כדי להתחיל.",
    "saveModalities": "שמור שיטות טיפול",
    "saveAllChanges": "",
    "saveAssessmentTools": "שמור כלי הערכה",
    "saveCarePathway": "שמור מסלול טיפולי",
    "saveReportPreferences": "שמור העדפות דוח",
    "reportTemplates": "תבניות דוחות",
    "reportTemplatesDesc": "עצבו והתאימו את מבנה דוחות המטופלים.",
    "aiCredits": "קרדיטים AI",
    "mskCredits": "קרדיטים MSK",
    "ownApiKey": "מפתח API משלכם",
    "aiCreditsDesc": "בחרו כיצד פועלות תכונות ה-AI.",
    "aiMode": "מצב AI",
    "useOwnApiKey": "השתמשו במפתח API שלכם",
    "useMskCredits": "השתמשו בקרדיטים של MSK Insight AI",
    "creditBalance": "יתרת קרדיטים",
    "creditRateFast": "קריאה מהירה = 1 קרדיט",
    "creditRateSmart": "קריאה חכמה = 5 קרדיטים",
    "creditRateFormat": "קריאת עיצוב = 1 קרדיט",
    "lowCreditsWarning": "קרדיטים נמוכים! תכונות AI עלולות להפסיק לפעול בקרוב. רכשו עוד קרדיטים.",
    "creditPacks": "חבילות קרדיטים",
    "buyCredits": "רכישת קרדיטים",
    "buyCreditsNote": "צרו קשר עם support@mskinsight.com לרכישה",
    "googleReviews": "ביקורות Google",
    "connected": "מחובר",
    "notConnected": "לא מחובר",
    "googleReviewsDesc": "חברו את קישור הביקורות של Google Business לשליחת בקשות ביקורת למטופלים בדוא\"ל או WhatsApp.",
    "googleReviewUrlLabel": "כתובת ביקורת Google",
    "googleReviewUrlHint": "מצאו את הקישור שלכם בפרופיל Google Business תחת \"קבלו עוד ביקורות\"",
    "saveReviewUrl": "שמור כתובת ביקורת",
    "whatsappBusiness": "WhatsApp Business",
    "notConfigured": "לא מוגדר",
    "whatsappBusinessDesc": "הגדירו את מספר WhatsApp Business ותבנית הודעה לתקשורת עם מטופלים.",
    "whatsappBusinessNumber": "מספר WhatsApp Business",
    "whatsappNumberHint": "כללו קידומת מדינה (למשל +357 לקפריסין, +44 לבריטניה)",
    "defaultMsgTemplate": "תבנית הודעה ברירת מחדל",
    "templateVariables": "משתנים זמינים: {patientName}, {clinicName}, {condition}, {reviewUrl}",
    "saveWhatsappSettings": "שמור הגדרות WhatsApp",
    "testWhatsapp": "בדיקת WhatsApp",
    "saveClinicType": "שמור סוג מרפאה",
    "demoMode": "מצב הדגמה",
    "demoModeDesc": "טען נתוני הדגמה. נתוני מטופלים אמיתיים לא יהיו גלויים.",
    "demoModeOn": "מצב הדגמה פעיל — נתוני מטופלים אמיתיים מוסתרים",
    "modalities": {
      "_TRANSLATE_ME": "Night 10 stub. All strings below are empty — i18next falls back to EN until translated. See ~/Desktop/MODALITIES-DECISIONS-LOCKED.md.",
      "title": "",
      "helperText": "",
      "clinicNotesHint": "",
      "clinicNotesPlaceholder": "",
      "customGroupLabel": "",
      "removeCustom": "",
      "addCustomTitle": "",
      "addCustomPlaceholder": "",
      "addCustomButton": "",
      "filledSummary": "",
      "groups": {
        "manual": {
          "label": ""
        },
        "active": {
          "label": ""
        },
        "modality_based": {
          "label": ""
        },
        "education": {
          "label": ""
        }
      },
      "items": {
        "spinal_manipulation": {
          "label": "",
          "description": ""
        },
        "instrument_adjusting": {
          "label": "",
          "description": ""
        },
        "drop_piece": {
          "label": "",
          "description": ""
        },
        "soft_tissue": {
          "label": "",
          "description": ""
        },
        "iastm": {
          "label": "",
          "description": ""
        },
        "dry_needling": {
          "label": "",
          "description": ""
        },
        "cupping": {
          "label": "",
          "description": ""
        },
        "neural_mobilisation": {
          "label": "",
          "description": ""
        },
        "joint_mobilisation": {
          "label": "",
          "description": ""
        },
        "rehab_exercises": {
          "label": "",
          "description": ""
        },
        "functional_movement": {
          "label": "",
          "description": ""
        },
        "clinical_pilates": {
          "label": "",
          "description": ""
        },
        "gait_retraining": {
          "label": "",
          "description": ""
        },
        "neuromuscular_reeducation": {
          "label": "",
          "description": ""
        },
        "breathing_exercises": {
          "label": "",
          "description": ""
        },
        "spinal_decompression": {
          "label": "",
          "description": ""
        },
        "shockwave": {
          "label": "",
          "description": ""
        },
        "laser": {
          "label": "",
          "description": ""
        },
        "tens": {
          "label": "",
          "description": ""
        },
        "ultrasound": {
          "label": "",
          "description": ""
        },
        "kinesio_taping": {
          "label": "",
          "description": ""
        },
        "rigid_taping": {
          "label": "",
          "description": ""
        },
        "normatec": {
          "label": "",
          "description": ""
        },
        "heat_therapy": {
          "label": "",
          "description": ""
        },
        "hydrotherapy": {
          "label": "",
          "description": ""
        },
        "red_light_therapy": {
          "label": "",
          "description": ""
        },
        "posture_analysis": {
          "label": "",
          "description": ""
        },
        "patient_education": {
          "label": "",
          "description": ""
        },
        "ergonomic_assessment": {
          "label": "",
          "description": ""
        },
        "nutritional": {
          "label": "",
          "description": ""
        }
      },
      "primaryDiscipline": {
        "title": "",
        "helperText": "",
        "options": {
          "chiropractic": {
            "label": "",
            "description": ""
          },
          "physiotherapy": {
            "label": "",
            "description": ""
          },
          "osteopathy": {
            "label": "",
            "description": ""
          },
          "sports_medicine": {
            "label": "",
            "description": ""
          },
          "multidisciplinary": {
            "label": "",
            "description": ""
          }
        }
      }
    },
    "_TRANSLATE_ME_NIGHT_12B": "Night 12b stub. Values marked '[_TRANSLATE_ME]' fall back to EN at render time. See proof/night12b/USER-EVIDENCE.md.",
    "navDiagnosticEquipment": "ציוד אבחון",
    "navOutcomeMeasuresAndTests": "מדדי תוצאה ובדיקות",
    "diagnosticEquipment": {
      "title": "ציוד אבחון",
      "subtitle": "בחרו את כלי האבחון וההערכה הזמינים במרפאה שלכם."
    },
    "outcomeMeasuresAndTests": {
      "title": "מדדי תוצאה ובדיקות",
      "helperText": "בחרו אילו מדדי תוצאה מדווחי-מטופל ואילו חבילות בדיקות אורתופדיות המרפאה שלכם משתמשת בהם. הצעות AI וזרימות הערכה יתאמו לכך."
    },
    "outcomeMeasures": {
      "sectionTitle": "מדדי תוצאה",
      "sectionSubtitle": "12 כלים מתוקפים מדווחי-מטופל. מדדים מושבתים לא יוצעו בזרימות הערכה.",
      "filledSummary": "{{count}} מתוך {{total}} מדדי תוצאה מופעלים",
      "groups": {
        "generic": {
          "label": "כללי"
        },
        "region_specific": {
          "label": "לפי איזור"
        },
        "psychosocial": {
          "label": "סריקה פסיכוסוציאלית"
        }
      },
      "items": {
        "PSFS": {
          "label": "Patient-Specific Functional Scale",
          "description": "המטופל מזהה 3-5 פעילויות המוגבלות על-ידי מצבו; מדרג יכולת 0-10."
        },
        "NPRS": {
          "label": "Numeric Pain Rating Scale",
          "description": "דירוג כאב חד-פריטי 0-10. מהיר, מובן באופן אוניברסלי."
        },
        "VAS": {
          "label": "Visual Analog Scale",
          "description": "קו רציף 0-100 מ\"מ לכאב או מדדים סובייקטיביים אחרים."
        },
        "GROC": {
          "label": "Global Rating of Change",
          "description": "דירוג רטרוספקטיבי יחיד של שינוי כללי מבסיס -7 עד +7."
        },
        "NDI": {
          "label": "Neck Disability Index",
          "description": "מדד נכות בן 10 פריטים למצבים צוואריים. ציון 0-50."
        },
        "ODI": {
          "label": "Oswestry Disability Index",
          "description": "מדד נכות בן 10 פריטים לכאב גב תחתון. ציון 0-100; MCID כ-10."
        },
        "DASH": {
          "label": "DASH — נכות גף עליון",
          "description": "Disabilities of the Arm, Shoulder and Hand. סולם בן 30 פריטים."
        },
        "LEFS": {
          "label": "Lower Extremity Functional Scale",
          "description": "דירוג תפקודי בן 20 פריטים למצבים שלד-שריריים בגף תחתון."
        },
        "PHQ9": {
          "label": "Patient Health Questionnaire-9",
          "description": "סקר חומרת דיכאון. ציון 0-27."
        },
        "GAD7": {
          "label": "Generalised Anxiety Disorder-7",
          "description": "סקר חומרת חרדה. ציון 0-21."
        },
        "STarT_Back": {
          "label": "STarT Back Screening Tool",
          "description": "שכבוב סיכון לכאב גב בן 9 פריטים (סיכון נמוך / בינוני / גבוה)."
        },
        "TSK11": {
          "label": "Tampa Scale Kinesiophobia-11",
          "description": "סולם פחד מתנועה בן 11 פריטים. ציון 11-44."
        }
      }
    },
    "orthopaedicTestPacks": {
      "sectionTitle": "חבילות בדיקות אורתופדיות",
      "sectionSubtitle": "14 חבילות בדיקה מקובצות לפי איזור. כל חבילה מפעילה סט מקוצב של בדיקות אורתופדיות בזרימת ההערכה.",
      "testCount": "{{count}} בדיקות",
      "filledSummary": "{{count}} מתוך {{total}} חבילות מופעלות ({{tests}} בדיקות זמינות)",
      "groups": {
        "axial": {
          "label": "צירי"
        },
        "upper_extremity": {
          "label": "גף עליון"
        },
        "lower_extremity": {
          "label": "גף תחתון"
        },
        "special": {
          "label": "מיוחד"
        }
      },
      "items": {
        "CERVICAL": {
          "label": "צווארי",
          "description": "Spurling, distraction, ULTT, סריקת עורק חולייתי ועוד 11."
        },
        "THORACIC": {
          "label": "גבי (חזה)",
          "description": "Spring testing, Adam forward bend, בדיקות מפרק צלעי-חוליי."
        },
        "LUMBAR": {
          "label": "מותני",
          "description": "SLR, slump, prone instability, Kemp ועוד 16."
        },
        "SI_JOINT": {
          "label": "מפרק עצה-כסלי (SIJ)",
          "description": "אשכול של 5 בדיקות פרובוקציה ל-SIJ (distraction, compression, thigh thrust, Gaenslen, sacral thrust)."
        },
        "SACRAL": {
          "label": "עצה",
          "description": "מישוש תנועת עצה, פרובוקציה של מפרק עצה-עוקץ, ניידות עוקץ."
        },
        "HEADACHE": {
          "label": "כאב ראש",
          "description": "בדיקות פרובוקציה של כאב ראש מקור צווארי וטיפוס מתח."
        },
        "SHOULDER": {
          "label": "כתף",
          "description": "Neer, Hawkins-Kennedy, Empty Can, O Brien, apprehension ועוד 15."
        },
        "ELBOW": {
          "label": "מרפק",
          "description": "Cozen, Mill, בדיקות מאמץ רצועות, Tinel ואחרות."
        },
        "WRIST_HAND": {
          "label": "שורש כף יד / כף יד",
          "description": "Phalen, Tinel בשורש, Finkelstein, בדיקות עצם הסירה ואחרות."
        },
        "HIP": {
          "label": "ירך",
          "description": "FABER, FADIR, Trendelenburg, בדיקת Thomas ועוד 8."
        },
        "KNEE": {
          "label": "ברך",
          "description": "Lachman, anterior drawer, McMurray, valgus/varus stress ועוד 15."
        },
        "ANKLE_FOOT": {
          "label": "קרסול / כף רגל",
          "description": "Anterior drawer, talar tilt, Thompson, בדיקות סינדסמוזיס ואחרות."
        },
        "DIZZINESS": {
          "label": "סחרחורת",
          "description": "Dix-Hallpike, סריקה וסטיבולרית-עינית-מוטורית (VOMS), סריקה צווארית."
        },
        "PAEDIATRIC": {
          "label": "ילדים",
          "description": "26 סריקות ייעודיות לילדים המכסות הליכה, יציבה, היפר-תנועתיות מפרקים ואבני-דרך התפתחותיות."
        }
      }
    },
    "carePathway": {
      "title": "הגדרות ברירת מחדל למסלול טיפול",
      "description": "הגדירו שלבי טיפול עם טווחי תדירות ומשך, הגדרות חומרה וכללי בדיקה חוזרת.",
      "phaseHeading": "שלב",
      "phaseName": "שם השלב",
      "subtitle": "כותרת משנה",
      "frequency": "תדירות",
      "frequencyTo": "עד",
      "visitsPer": "ביקורים ב",
      "duration": "משך",
      "weeks": "שבועות",
      "ongoing": "מתמשך",
      "frequencyBlocks": "בלוקי תדירות",
      "frequencyBlocksHint": "(אופציונלי — לשימוש ביצירת לוח ביקורים)",
      "blockThen": "לאחר מכן",
      "blockFor": "למשך",
      "addFrequencyBlock": "+ הוסף בלוק תדירות",
      "goals": "מטרות",
      "goalPlaceholder": "הזן מטרה...",
      "addGoal": "+ הוסף מטרה",
      "patientMessage": "הודעה למטופל",
      "patientMessagePlaceholder": "הודעה המוצגת למטופלים בדוחות...",
      "remove": "הסר",
      "addPhase": "+ הוסף שלב",
      "severityPresets": "הגדרות חומרה מראש",
      "severityMild": "קל",
      "severityModerate": "בינוני",
      "severitySevere": "חמור",
      "severityFor": "למשך",
      "severityWk": "שבוע",
      "reExamRules": "כללי בדיקה חוזרת",
      "firstReExamAfter": "בדיקה חוזרת ראשונה לאחר",
      "thenEvery": "לאחר מכן בכל",
      "visits": "ביקורים",
      "customRule": "כלל מותאם אישית (אופציונלי)",
      "customRulePlaceholder": "לדוגמה, תמיד בדיקה חוזרת לאחר חופשות בית הספר",
      "terminology": "העדפת מינוח",
      "wellnessCare": "טיפול אחזקתי",
      "maintenanceCare": "טיפול תחזוקה",
      "livePreview": "תצוגה חיה",
      "previewLabel": "תצוגה",
      "reExam": "בדיקה חוזרת:",
      "reExamSentence": "נסקור את ההתקדמות שלכם לאחר {{firstMin}}-{{firstMax}} ביקורים, ואז בכל {{recMin}}-{{recMax}} ביקורים.",
      "periodWeek": "שבוע",
      "periodFortnight": "שבועיים",
      "periodMonth": "חודש"
    },
    "checker": {
      "sectionTitle": "בודק תסמינים",
      "sectionDescription": "דף בודק התסמינים הציבורי שלכם למטופלים ולקמפיינים פרסומיים.",
      "statusLive": "פעיל",
      "statusNotActivated": "לא הופעל",
      "preview": "תצוגה מקדימה",
      "copy": "העתק",
      "copied": "הועתק!",
      "adCampaignTitle": "כתובות URL לקמפיין פרסומי",
      "adCampaignDescription": "השתמשו בכתובות אלה בפרסומות שלכם בפייסבוק, גוגל ואינסטגרם כדי לכוון מטופלים לבודק התסמינים בשפה ובאזור הגוף הנכונים.",
      "enableAtLeastOne": "הפעילו לפחות שפה אחת בהתאמה האישית של הבודק למטה.",
      "baseUrl": "כתובת בסיס",
      "copyAll": "העתק הכל",
      "regionLumbar": "כאבי גב",
      "regionCervical": "כאבי צוואר",
      "regionShoulder": "כתף",
      "regionKnee": "ברך",
      "customisationTitle": "התאמה אישית של הבודק",
      "customisationDescription": "הגדירו שפות, אפשרויות תצוגה ומעקב לבודק התסמינים שלכם.",
      "languages": "שפות",
      "defaultLanguage": "שפת ברירת מחדל",
      "displayOptions": "אפשרויות תצוגה",
      "showConfidence": "הצג ציון ביטחון",
      "showClinicalTerms": "הצג מונחים קליניים",
      "showShareButton": "הצג כפתור שיתוף",
      "showDisclaimer": "הצג הצהרה",
      "customDisclaimer": "הצהרה מותאמת אישית",
      "customDisclaimerPlaceholder": "השאירו ריק לשימוש בהצהרה ברירת מחדל",
      "whatsappTemplate": "תבנית הודעת WhatsApp",
      "whatsappTemplateHint": "השתמשו ב-{{conditionPh}} וב-{{regionPh}} כמשתנים.",
      "gaId": "מזהה Google Analytics",
      "fbPixelId": "מזהה Facebook Pixel",
      "bookingButtonsTitle": "כפתורי הזמנה",
      "bookingButtonsDescription": "בחרו אילו כפתורי קשר יופיעו בעמוד תוצאות הבודק.",
      "showBookOnline": "הצג כפתור \"הזמנה אונליין\"",
      "showBookOnlineNoUrl": "הצג כפתור \"הזמנה אונליין\" (לא נקבעה כתובת הזמנה)",
      "showWhatsapp": "הצג כפתור \"WhatsApp\"",
      "showWhatsappNoNumber": "הצג כפתור \"WhatsApp\" (לא נקבע מספר WhatsApp)",
      "showCall": "הצג כפתור \"התקשרות\"",
      "showCallNoPhone": "הצג כפתור \"התקשרות\" (לא נקבע מספר טלפון)",
      "usageTitle": "שימוש",
      "usageLoading": "טוען נתוני שימוש...",
      "usageUnableToLoad": "לא ניתן לטעון נתוני שימוש.",
      "usageChecksThisMonth": "בדיקות החודש",
      "usageUnlimited": "(ללא הגבלה)",
      "saveButton": "שמור הגדרות בודק",
      "saving": "שומר..."
    },
    "reportPreferences": {
      "title": "העדפות דוחות ומכתבים לרופא המשפחה",
      "description": "הגדירו תוכן דוחות, שפות ועיצוב מכתבים לרופא המשפחה.",
      "reportLanguages": "שפות דוחות",
      "defaultReportLanguage": "שפת דוח ברירת מחדל",
      "reportContentHeading": "תוכן דוח מטופל",
      "includeTeam": "כלול קטע צוות",
      "includeStatistics": "כלול קטע סטטיסטיקה/מחקר",
      "includeSupplements": "כלול קטע תוספי תזונה",
      "includeExercises": "כלול תוכנית תרגילים",
      "commonReferralSpecialists": "מומחי הפניה נפוצים (אחד בכל שורה)",
      "commonReferralSpecialistsPlaceholder": "כירורג אורתופדי\nנוירולוג\nראומטולוג"
    },
    "navAuditLog": "יומן ביקורת",
    "navPrivacy": "נתונים ופרטיות",
    "navSecurity": "אבטחה",
    "frontDeskModule": "קבלה",
    "frontDeskModuleDesc": "התאמת זימונים, תורי חידוש ואי-הגעה, אישורים ומסירת משמרת. סנכרון התורים ממשיך בין אם האפשרות פעילה ובין אם לא.",
    "practiceHub": "PracticeHub",
    "practiceHubDesc": "סנכרון מטופלים וניהול מסמכים. התורים ותיקי המטופלים נמשכים מחשבון ה-PracticeHub שלך.",
    "enablePracticeHub": "הפעלת סנכרון PracticeHub",
    "phBaseUrl": "כתובת URL בסיסית של PracticeHub",
    "phApiKey": "מפתח API",
    "phApiKeyPlaceholder": "הזינו מפתח API",
    "phApiKeyFingerprint": "טביעת אצבע של המפתח: {{fp}} — השאירו ריק כדי לשמור",
    "phApiKeyIsV3": "זהו מפתח של ה-API החדש (phk_). ‏MSK Insight עדיין לא משתמש במפתחות כאלה; שמרו אותו לחיבור v3 הקרוב.",
    "phSavedKeyAccepted": "נשמר — PracticeHub קיבל את המפתח ({{patients}} רשומות מטופלים גלויות).",
    "phSavedKeyRefused": "נשמר, אבל PracticeHub דחה אותו. ודאו שהעתקתם את המפתח המלא מ-PracticeHub.",
    "phSavedKeyRateLimited": "נשמר, אבל PracticeHub מגביל בקשות כרגע. לחצו על בדיקת חיבור בעוד כמה דקות.",
    "phSavedKeyUntested": "נשמר, אבל לא ניתן היה להגיע ל-PracticeHub כדי לבדוק אותו. לחצו על בדיקת חיבור.",
    "phAppDetails": "פרטי היישום",
    "phAppDetailsHint": "שם היישום ש-PracticeHub מציג עבור חיבור זה.",
    "savePracticeHubConfig": "שמירת הגדרות PracticeHub",
    "phTestOk": "מחובר — {{patients}} תיקי מטופלים גלויים.",
    "phTestOkNoCount": "מחובר.",
    "phTestFailed": "בדיקת החיבור נכשלה",
    "phSaved": "הגדרות PracticeHub נשמרו.",
    "phSaveFailed": "שמירת הגדרות PracticeHub נכשלה."
  },
  "audit": {
    "title": "יומן ביקורת",
    "dateFrom": "מתאריך",
    "dateTo": "עד תאריך",
    "user": "משתמש",
    "searchByName": "חיפוש לפי שם...",
    "action": "פעולה",
    "entity": "ישות",
    "applyFilters": "החל מסננים",
    "recordsFound": "{{count}} רשומה(ות) נמצאו",
    "noEntries": "לא נמצאו רשומות יומן ביקורת התואמות למסננים הנוכחיים.",
    "table": {
      "timestamp": "חותמת זמן",
      "user": "משתמש",
      "action": "פעולה",
      "entity": "ישות",
      "details": "פרטים"
    },
    "page": "עמוד {{current}} מתוך {{total}}",
    "actions": {
      "all": "כל הפעולות",
      "create": "יצירה",
      "read": "קריאה",
      "update": "עדכון",
      "delete": "מחיקה",
      "login": "כניסה",
      "logout": "יציאה",
      "export": "ייצוא",
      "consent": "הסכמה"
    },
    "entities": {
      "all": "כל הישויות",
      "patient": "מטופל",
      "assessment": "הערכה",
      "user": "משתמש",
      "consent": "הסכמה",
      "report": "דוח",
      "referral": "הפניה"
    }
  },
  "gdpr": {
    "title": "GDPR ופרטיות נתונים",
    "description": "ניהול זכויות נתוני מטופלים כולל ייצוא, מחיקה ואנונימיזציה בהתאם ל-GDPR.",
    "findPatient": "מצא מטופל",
    "searchPlaceholder": "חיפוש לפי שם, אימייל או מזהה מטופל...",
    "searching": "מחפש...",
    "selectedPatient": "מטופל נבחר",
    "dataExport": "ייצוא נתונים",
    "exportDesc": "ייצוא כל נתוני המטופל כקובץ JSON. כולל מידע אישי, הערכות, הסכמות ורשומות קליניות.",
    "exporting": "מייצא...",
    "exportButton": "ייצוא נתוני מטופל (JSON)",
    "rightToForget": "הזכות להישכח",
    "rightToForgetDesc": "מחיקה קבועה של כל נתוני המטופל. פעולה זו בלתי הפיכה ותתוזמן עם תקופת חסד.",
    "requestDeletion": "בקש מחיקת נתונים",
    "typeDeleteConfirm": "הקלד DELETE לאישור מחיקה לצמיתות:",
    "processing": "מעבד...",
    "confirmDelete": "אשר מחיקה",
    "anonymization": "אנונימיזציה",
    "anonymizationDesc": "הסרת מזהים אישיים תוך שמירת נתונים קליניים למחקר ואנליטיקה.",
    "anonymizeButton": "אנונימיזציה של נתוני מטופל",
    "anonymizeWarning": "פעולה זו תסיר את כל המזהים האישיים. נתונים קליניים יישמרו באופן אנונימי.",
    "confirmAnonymize": "אשר אנונימיזציה",
    "consentOverview": "סקירת הסכמות לעיבוד נתונים",
    "noConsent": "לא נמצאו רשומות הסכמה למטופל זה.",
    "consentTable": {
      "type": "סוג הסכמה",
      "status": "סטטוס",
      "lastUpdated": "עדכון אחרון"
    }
  },
  "wizard": {
    "step": "שלב",
    "of": "מתוך",
    "saveAndExit": "שמירה ויציאה",
    "aiAnalysingImages": "AI מנתח {{count}} תמונה",
    "stepNames": {
      "1": "תלונות עיקריות",
      "2": "היסטוריה רפואית",
      "3": "בדיקה גופנית",
      "4": "ניתוח יציבה",
      "5": "בדיקות",
      "6": "מדדי תוצאה",
      "7": "סקירת DDx",
      "8": "תוכנית טיפול",
      "9": "יצירת דוח"
    },
    "fullAssessment": "הערכה מלאה",
    "quickScore": "ציון מהיר",
    "reExamination": "בדיקה חוזרת",
    "stepOf": "שלב {{current}} מתוך {{total}}",
    "paediatric": "ילדים",
    "finalized": "הושלם",
    "savedAt": "נשמר {{time}}",
    "saveAndContinueTo": "שמור והמשך ל{{stepName}} →",
    "saveAndContinue": "שמור והמשך →",
    "previousSection": "← הסעיף הקודם",
    "completeAssessment": "✓ השלם הערכה",
    "optional": "אופציונלי",
    "loadingAssessment": "טוען הערכה…",
    "goBack": "חזור",
    "noPatientSelected": "לא נבחר מטופל. התחל הערכה מפרופיל המטופל.",
    "viewPatients": "צפה במטופלים",
    "saveAsDraft": "💾 שמור כטיוטה — הקבלה תשלים",
    "continueToReport": "המשך ליצירת דוח →",
    "finalizeReport": "סיים דוח",
    "finalizeReady": "כאשר כל הסעיפים מוכנים, סיים את הדוח.",
    "reportFinalized": "הדוח הושלם ומוכן למטופל.",
    "stepComingSoon": "שלב {{step}} — התוכן יגיע בקרוב.",
    "saveDraft": "שמור טיוטה",
    "validation": {
      "complaintsRequired": "אנא הוסיפו לפחות תלונה אחת לפני המשך."
    },
    "finalizeErrorTitle": "הסופיות לא הושלמה.",
    "finalizeAlreadyIssued": "הדוח הזה כבר הונפק. פתחו אותו מחדש לתיקון כדי לפרסם גרסה חדשה.",
    "finalizeNotAuthor": "רק הקלינאי שהנפיק את הדוח הזה יכול לתקן אותו.",
    "finalizeFailed": "שום דבר לא נשמר. אנא נסו שוב.",
    "noFrequency": {
      "title": "לא הוגדרה תדירות טיפול",
      "body": "לתוכנית זו אין בלוקים של תדירות טיפול, ולכן בדוח לא יהיה לוח ביקורים.",
      "applyDefault": "החל {{preset}} והשלם",
      "completeAnyway": "השלמה ללא תוכנית תדירות",
      "presetMissing": "לא ניתן היה לטעון את ברירת המחדל — הגדר את התדירות בשלב תוכנית הניהול.",
      "lowVisitsTitle": "מספר הביקורים הפעילים בתוכנית: {{count}}. להפיק בכל זאת?",
      "lowVisitsBody": "תוכנית קצרה כל כך אינה מהווה סדרת טיפולים, ולכן הדוח לא יציג מועד סיום משוער. אפשר להחיל תחילה תבנית, או להפיק את הדוח כפי שהוא.",
      "noPresetTitle": "לא הוחלה תבנית על התוכנית הזו. להפיק בכל זאת?",
      "noPresetBody": "ללא תבנית, הדוח לא יציג מועד סיום משוער. אפשר להחיל תחילה את תבנית ברירת המחדל של המרפאה, או להפיק את הדוח כפי שהוא.",
      "issueAnyway": "להפיק בכל זאת"
    }
  },
  "patientReport": {
    "dear": "לכבוד",
    "introP1": "תודה שבחרת ב-{{clinicName}} לטיפולך. בעקבות ההערכה המקיפה שביצענו, אנו שמחים לשתף אותך בדוח אישי זה. הוא מסביר את מה שמצאנו, כיצד אנו מתכננים לסייע לך, ומה תוכל/י לעשות בבית כדי לתמוך בהחלמה. אנו רוצים שתרגיש/י בטוח/ה ומעודכן/ת בכל שלב בדרך.",
    "introP2": "המטרה שלנו היא לא רק לעזור לך להרגיש טוב יותר, אלא לעזור לך להישאר בריא/ה. אנחנו כאן כדי לתמוך בך בכל שלב במסע הטיפול שלך.",
    "whatWeFound": "מה מצאנו",
    "aiSummaryTitle": "סיכום הביקור שלך",
    "whatWeFoundIntro": "בהתבסס על ההיסטוריה הרפואית ועל הבדיקה שלכם, הממצאים מתאימים במידה הרבה ביותר להשערות העבודה הבאות. הן מתארות דפוסים שעשויים לתרום לתסמינים שלכם; הן אינן מאשרות מבנה מסוים אחד כמקור המדויק לכאב, וייתכן שיתעדכנו ככל שנעקוב אחר ההתקדמות שלכם או נקבל מידע חדש. תוכנית הטיפול שלכם מונחית לפי התסמינים, התפקוד, ממצאי הבדיקה, המטרות והתגובה לטיפול, ולא לפי הכותרת בלבד. במקרים המתאימים נמליץ גם על הערכה רפואית או על בירור נוסף.",
    "whatIsIt": "מהו המצב?",
    "howDoesItHappen": "כיצד זה קורה?",
    "whatCanBeDone": "מה ניתן לעשות?",
    "whatToExpect": "מה לצפות?",
    "whatDoesThisMean": "מה זה אומר?",
    "reExamDisclaimer": "מחקר מצביע על מסגרות זמן טיפוסיות של החלמה ותדירויות טיפול עבור מצבים אלה. אנו מעדיפים להתקדם עם התוכנית המוצעת ולבחון מחדש את ההתקדמות שלכם לאורך הדרך. בדיקות חוזרות אלה עוזרות לנו להשוות איך הייתם, איך אתם, ולהחליט כיצד נמשיך יחד.",
    "yourProgress": "ההתקדמות שלך",
    "yourTreatmentPlan": "תוכנית הטיפול שלך",
    "treatmentPlanIntro": "הטיפול שלך בנוי בשלבים, כאשר כל שלב נועד לבנות על ההתקדמות של הקודם. חשוב/י על כך כמסע מהקלת כאב, דרך שיקום, ועד לבריאות לטווח ארוך.",
    "expectedDuration": "משך צפוי",
    "treatmentsConcurrent": "(הטיפולים בכל המצבים מתבצעים במקביל)",
    "phase": "שלב",
    "duration": "משך",
    "weeks": "שבועות",
    "frequency": "תדירות",
    "phaseTableStage": "שלב הטיפול",
    "phaseTableCondition": "מצב",
    "phaseTableFocus": "מיקוד",
    "phaseTableCadenceNote": "תדירות הביקורים מוצגת בלוח תדירות הטיפול שלמטה.",
    "techniques": "טכניקות",
    "goals": "מטרות",
    "goldenRulesTitle": "כללי הזהב שלך",
    "goldenRulesIntro": "אלה הדברים החשובים לזכור בין הטיפולים. שמירה על הנחיות אלו תעזור לך לקבל את התוצאות הטובות ביותר מהטיפול.",
    "doNow": "לעשות עכשיו",
    "thingsToAvoid": "דברים להימנע מהם",
    "lifestyleChanges": "שינויים באורח חיים",
    "homeCareTitle": "המלצות לטיפול ביתי",
    "supplementsTitle": "תוספי תזונה מומלצים",
    "supplementsIntro": "תוספי תזונה אלו מומלצים על סמך ההערכה שלך כדי לתמוך בהחלמה. תמיד התייעץ עם הרופא הכללי או הרוקח שלך לפני תחילת נטילה של תוספים חדשים, במיוחד אם אתה נוטל תרופות.",
    "supplement": "תוסף",
    "yourWellnessScore": "ציון הביצועים הגופניים שלך",
    "wellnessScoreIntro": "ציון הביצועים הגופניים שלך משקף היבטים מרובים של בריאות שלד-שריר. התרשים שלהלן מציג את הביצועים בכל תחום — נעקוב אחר שיפורים לאורך זמן.",
    "overallScore": "ציון כולל",
    "scoreExcellent": "מצוין — המשיכ/י כך!",
    "scoreGood": "טוב — עם טיפול ממוקד תוכל/י להגיע למיטבך.",
    "scoreFair": "סביר — יש מקום לשיפור, והתוכנית שלנו נועדה לסייע בכך.",
    "scoreNeedsAttention": "דורש תשומת לב — תוכנית הטיפול שלנו מתמקדת בתחומים שזקוקים לעזרה הרבה ביותר.",
    "exercisesTitle": "תרגילים מומלצים",
    "exerciseSets": "סטים",
    "exerciseReps": "חזרות",
    "exerciseHold": "החזקה",
    "exerciseSec": "שניות",
    "whyOngoingCare": "למה טיפול מתמשך חשוב",
    "ongoingCareP1": "מחקרים מראים באופן עקבי שמטופלים המשלימים את מלוא מהלך הטיפול — כולל שלב הבריאות — חווים תוצאות טובות יותר לטווח הארוך. הפסקת טיפול כשהכאב נעלם דומה להפסקת אנטיביוטיקה באמצע הקורס: התסמינים אולי נעלמו, אך הבעיה הבסיסית לא נפתרה במלואה.",
    "ongoingCareP2": "מסלול הטיפול שלך:",
    "carePhase1": "טיפול הקלה — הפחתת כאב ודלקת",
    "carePhase2": "שיקום — שחזור כוח ותפקוד",
    "carePhase3": "טיפול הרווחה — תמיכה בתנועה, תפקוד וניהול עצמי לטווח ארוך",
    "ongoingCareP3": "מטופלים שמשלימים את שלב הבריאות עשויים לחוות פחות הישנויות. אנו ממליצים בחום להשלים את כל שלבי הטיפול.",
    "yourCareTeam": "צוות הטיפול שלך",
    "careTeamIntro": "את/ה בידיים טובות. צוות המטפלים המנוסה שלנו מחויב לסייע לך להגיע לתוצאה הטובה ביותר האפשרית.",
    "nextSteps": "הצעדים הבאים",
    "nextStepsIntro": "מוכנ/ה להתחיל את המסע לבריאות טובה יותר? קבע/י את התור הבא שלך עוד היום.",
    "phone": "טלפון",
    "email": "אימייל",
    "website": "אתר אינטרנט",
    "instagram": "אינסטגרם",
    "footer": "דוח זה מסופק למטרות חינוכיות כחלק מתוכנית הטיפול שלך. המצבים המפורטים מייצגים השערות עבודה לשיקול קליני בלבד ואין לראות בהם אבחנות סופיות. אנא דון/דוני בכל שאלה עם המטפל/ת שלך.",
    "footerOneLine": "סיכום מידע — המצבים המפורטים הם השערות עבודה לשיקול קליני, לא אבחנות סופיות. נא לדון בכל שאלה עם המטפל/ת שלך.",
    "cta": {
      "whatsappLabel": "WhatsApp",
      "whatsappPrefix": "שלחו לנו הודעה ב-WhatsApp:",
      "referTitle": "הפנו חבר",
      "referHeading": "מכירים מישהו שעשוי להפיק תועלת מהטיפול שלנו?",
      "referLine1": "נשמח לעזור גם למשפחה ולחברים שלכם.",
      "referLine2": "אם אתם מכירים מישהו שעשוי להפיק תועלת, יהיה זה כבוד עבורנו לקבל אותו.",
      "referShare": "שתפו",
      "googleReviewCtaTitle": "עזרו לאחרים למצוא אותנו",
      "googleReviewCtaBody": "אם עזרנו לכם, נשמח אם תשקלו להשאיר ביקורת של 5 כוכבים בגוגל. זה לוקח 30 שניות ועוזר לאנשים למצוא טיפול איכותי.",
      "googleReviewCtaButton": "השאר ביקורת בגוגל"
    }
  },
  "preview": {
    "tabs": {
      "clinician": "קלינאי",
      "patient": "מטופל"
    }
  },
  "redFlags": {
    "title": "סינון דגלים אדומים",
    "instructions": "ענה כן או לא על כל שאלת סינון. נשאלים פעם אחת לכל ההערכה.",
    "emergencyDetected": "זוהה מצב חירום רפואי",
    "emergencyMessage": "זוהו מצבי חירום רפואיים. בדוק מיד ונקוט בפעולה המתאימה.",
    "flagsDetected": "זוהו דגלים אדומים",
    "emergencyAndFlags": "זוהו מצבי חירום ודגלים אדומים",
    "emergencyInstruction": "עצור: יש לטפל בדגלי החירום לפני כל פרוצדורה קלינית. כל הדגלים דורשים פעולה מהרופא לפני המשך.",
    "flagsInstruction": "הדגלים האדומים הבאים דורשים פעולה מהרופא לפני המשך.",
    "screeningComplete": "סינון דגלים אדומים הושלם. לא נמצאו בעיות הדורשות פעולה מיידית.",
    "backToReview": "← חזרה לסקירת תלונות",
    "reviewed": "דגלים אדומים נבדקו — השתמש בניווט למטה כדי להמשיך",
    "submitting": "שולח...",
    "submitAndContinue": "שלח סינון והמשך →"
  },
  "statusBadges": {
    "draft": "טיוטה",
    "in_progress": "בתהליך",
    "clinician_draft": "ממתין לקבלה",
    "front_desk_review": "הקבלה עובדת",
    "completed": "הושלם",
    "finalized": "סופי"
  },
  "carePhases": {
    "initial": "ראשוני",
    "active": "טיפול פעיל",
    "maintenance": "תחזוקה",
    "wellness": "בריאות"
  },
  "bodyRegions": {
    "headache": "כאב ראש",
    "dizziness": "סחרחורת",
    "cervical": "צווארי",
    "thoracic": "חזי",
    "lumbar": "מותני",
    "sacral": "עצה",
    "shoulder_left": "כתף שמ.",
    "shoulder_right": "כתף ימ.",
    "elbow_left": "מרפק שמ.",
    "elbow_right": "מרפק ימ.",
    "wrist_hand_left": "שורש יד שמ.",
    "wrist_hand_right": "שורש יד ימ.",
    "hip_left": "ירך שמ.",
    "hip_right": "ירך ימ.",
    "knee_left": "ברך שמ.",
    "knee_right": "ברך ימ.",
    "ankle_foot_left": "קרסול שמ.",
    "ankle_foot_right": "קרסול ימ.",
    "tmj": "לסת",
    "growing_pains": "כאבי גדילה",
    "torticollis": "טורטיקוליס"
  },
  "infant": {
    "reportTitle": "דוח בריאות התינוק שלכם",
    "progressUpdate": "עדכון התקדמות",
    "initialAssessment": "הערכה ראשונית",
    "patientLabel": "מטופל",
    "ageLabel": "גיל",
    "dateOfBirthLabel": "תאריך לידה",
    "infantAssessment": "הערכת תינוק",
    "loadingAssessment": "טוען הערכת תינוק...",
    "assessmentTitle": "הערכת תינוק (0-12 חודשים)",
    "assessmentDescription": "סינון מקיף לתינוקות — אנא השלם את כל הסעיפים כדי שנוכל לספק את הטיפול הטוב ביותר.",
    "completeAndContinue": "השלם הערכת תינוק והמשך",
    "sectionsComplete": "{{completed}} מתוך {{total}} סעיפים הושלמו",
    "monthsOld": "בן/בת {{count}} חודשים",
    "oneMonthOld": "בן/בת חודש",
    "infantLabel": "תינוק",
    "na": "לא זמין",
    "pronouns": {
      "heMale": "הוא",
      "hisMale": "שלו",
      "himMale": "אותו",
      "HeMale": "הוא",
      "HisMale": "שלו",
      "heFemale": "היא",
      "hisFemale": "שלה",
      "himFemale": "אותה",
      "HeFemale": "היא",
      "HisFemale": "שלה",
      "heNeutral": "התינוק",
      "hisNeutral": "של התינוק",
      "himNeutral": "את התינוק",
      "HeNeutral": "התינוק",
      "HisNeutral": "של התינוק"
    },
    "greeting": {
      "dearGuardianWithRel": "{{name}} היקר/ה ({{relationship}} של {{child}}),",
      "dearGuardian": "{{name}} היקר/ה,",
      "dearParents": "הורים יקרים,",
      "intro": "תודה שהבאתם את {{child}} ל{{visitType}}. אנו יודעים שהטיפול בתינוק מלווה בשאלות ודאגות רבות, ואנו רוצים שתדעו שאנחנו כאן לתמוך בכם. להלן סיכום הממצאים שלנו מהיום וההמלצות שלנו לטיפול ב{{child}}.",
      "followUp": "בדיקת מעקב",
      "assessment": "הערכה"
    },
    "findings": {
      "title": "מה מצאנו היום",
      "howDoesItHappen": "כיצד זה קורה?",
      "whatCanBeDone": "מה ניתן לעשות?",
      "noConcerns": "לא זיהינו בעיות מסוימות במהלך ההערכה של היום. {{child}} מתפתח/ת היטב. הכנו עבורכם מספר הנחיות כלליות להלן לתמיכה בהתפתחות {{possessive}} השוטפת.",
      "yourConcerns": "הדאגות שלכם",
      "concernsIntro": "ציינתם את הדאגות הבאות: {{concerns}}. לקחנו אותן בחשבון בהערכה ובהמלצות שלנו להלן."
    },
    "tummyTime": {
      "title": "תוכנית זמן בטן",
      "forChild": "עבור {{child}} ({{age}}): {{minutes}}, {{frequency}}",
      "importance": "זמן בטן הוא הפעילות החשובה ביותר להתפתחות הגופנית של התינוק. הוא מחזק את שרירי הצוואר, הכתפיים והגו הנדרשים להתהפכות, ישיבה וזחילה.",
      "minutes1": "3–5 דקות",
      "frequency1": "2–3 פעמים ביום",
      "tip1_1": "התחילו עם זמן בטן על החזה שלכם כשאתם בתנוחה מוטה לאחור",
      "tip1_2": "הניחו את התינוק על משטח יציב עם מגבת מגולגלת קטנה מתחת לחזה",
      "tip1_3": "הישארו קרובים ודברו או שירו כדי לשמור על התינוק מעורב",
      "tip1_4": "הפסיקו אם התינוק מצטער ונסו שוב מאוחר יותר",
      "minutes2": "10–15 דקות",
      "frequency2": "3–4 פעמים ביום",
      "tip2_1": "השתמשו במשטח משחק עם צעצועים צבעוניים בגובה העיניים",
      "tip2_2": "הניחו מראה קטנה מול התינוק לעידוד הרמת ראש",
      "tip2_3": "נסו זמן בטן על הברכיים שלכם לגיוון",
      "tip2_4": "תמכו בתינוק על מגבת מגולגלת או כרית הנקה מתחת לחזה",
      "minutes3": "20–30 דקות",
      "frequency3": "4–5 פעמים ביום",
      "tip3_1": "סדרו צעצועים בחצי עיגול לעידוד הושטת ידיים וסיבובים",
      "tip3_2": "אפשרו לתינוק לשחק על הבטן בזמן משחק חופשי על הרצפה",
      "tip3_3": "נסו תמיכה על האמות לחיזוק פלג הגוף העליון",
      "tip3_4": "עודדו התהפכות על ידי הנחת צעצועים מעט מחוץ להישג יד לצד אחד",
      "minutes4": "30+ דקות",
      "frequency4": "לאורך היום במהלך המשחק",
      "tip4_1": "תנו לתינוק לחקור חופשי על הרצפה באזור בטוח",
      "tip4_2": "עודדו זחילה על ידי הנחת צעצועים במרחק",
      "tip4_3": "תמכו בעמידה ובהליכה לאורך רהיטים",
      "tip4_4": "המשיכו במשחק על הרצפה כפעילות העיקרית"
    },
    "headShape": {
      "title": "ייעוץ לצורת הראש",
      "alternateCot": "החליפו את הכיוון שבו {{child}} מופנה בעריסה כל לילה",
      "encourageLook": "עודדו את {{child}} להסתכל לכיוון הצד הלא שטוח במהלך המשחק",
      "minimiseFlat": "צמצמו זמן על משטחים שטוחים — השתמשו במנשא או החזיקו את {{child}} בתנוחה זקופה",
      "continueTummy": "המשיכו בזמן בטן בפיקוח כטיפול הטוב ביותר למקומות שטוחים",
      "noSleepChange": "אל תשנו את תנוחת השינה — תמיד הניחו את {{child}} על {{possessive}} גב לשינה",
      "reassurance": "רוב שינויי צורת הראש המיקומיים משתפרים משמעותית ככל שהתינוק שלכם רוכש שליטה בראש ומבלה פחות זמן בשכיבה."
    },
    "feeding": {
      "title": "הנחיות האכלה",
      "sidePreference": "{{child}} מעדיף/ה האכלה מצד אחד. נסו להחליף צדדים בכל האכלה לעידוד תנועת צוואר שווה. אם {{pronoun}} מתנגד/ת, נסו תנוחת האכלה שונה (למשל, אחיזת כדורגל) בצד הפחות מועדף.",
      "difficultyLatching": "צוינה קושי בנעילה — שקלו ייעוץ עם מומחית הנקה אם זה נמשך.",
      "fussesDuringFeeds": "{{child}} חסר/ת מנוחה במהלך ההאכלה — ייתכן שזה קשור לריפלוקס או אי נוחות. נסו ארוחות קטנות ותכופות יותר.",
      "archesBack": "התקמרות הגב במהלך האכלה עשויה להצביע על ריפלוקס. החזיקו את {{child}} בתנוחה יותר זקופה במהלך ואחרי ההאכלה.",
      "fallsAsleep": "אם {{child}} נרדם/ת מהר במהלך ההאכלה, נסו גירוי עדין (דגדגו כפות רגליים, מטלית קרירה) לעידוד האכלה ממושכת יותר.",
      "spitsUp": "פליטות תכופות נפוצות אצל תינוקות. החזיקו את {{child}} בתנוחה זקופה למשך 20–30 דקות אחרי ההאכלה.",
      "refluxTitle": "טיפים לניהול ריפלוקס:",
      "reflux1": "החזיקו בתנוחה זקופה 20–30 דקות אחרי כל ארוחה",
      "reflux2": "הציעו ארוחות קטנות ותכופות יותר",
      "reflux3": "סייעו בגיהוק בעדינות במהלך ואחרי ההאכלה",
      "reflux4": "הרימו מעט את צד הראש של המיטה"
    },
    "carrying": {
      "title": "ייעוץ לנשיאה והחזקה",
      "hipHealthy": "נשיאה בריאה לירכיים",
      "hipHealthyDesc": "נשאו את {{child}} עם הרגליים {{possessive}} פשוקות סביב הירך שלכם בתנוחת צפרדע. השתמשו במנשא עם בסיס רחב התומך בירכיים מברך לברך.",
      "varyPositions": "שנו תנוחות",
      "varyPositionsDesc": "החליפו את היד שבה אתם נושאים את {{child}}. נסו לפנות כלפי חוץ לעודד את {{child}} להסתכל מסביב ולחזק שרירי צוואר.",
      "forTorticollis": "עבור טורטיקוליס",
      "torticollisDesc": "נשאו את {{child}} כך ש{{pronoun}} יצטרך/תצטרך לסובב את הראש {{possessive}} לכיוון הצד המתוח כדי לראות אתכם. כאשר {{child}} בזרועותיכם, מקמו {{objective}} כך שדברים מעניינים יהיו בצד הפחות מועדף {{possessive}}.",
      "forHipDysplasia": "עבור דיספלזיה של הירך",
      "hipDysplasiaDesc": "תמיד נשאו את {{child}} עם הרגליים פשוקות סביבכם (תנוחת רכיבה). הימנעו ממנשאים צרים שמאלצים את הרגליים יחד. בעת חיתול, אפשרו לרגליים {{possessive}} להיות בתנוחת צפרדע טבעית."
    },
    "milestones": {
      "title": "ציפיות לאבני דרך התפתחותיות",
      "disclaimer": "כל תינוק מתפתח בקצב שלו. אבני הדרך לעיל הן הנחיות כלליות. אם יש לכם דאגות לגבי התפתחות {{child}}, אנא דונו בהן איתנו או עם רופא הילדים שלכם.",
      "notCompleted": "מעקב אבני דרך לא הושלם במהלך ההערכה של היום. אנא דונו בכל דאגה התפתחותית עם רופא הילדים שלכם."
    },
    "carePlan": {
      "title": "תוכנית הטיפול של {{child}}",
      "phase": "שלב",
      "frequencyLabel": "תדירות:",
      "durationLabel": "משך:",
      "goals": "מטרות",
      "techniques": "טכניקות",
      "visitFrequency": "תדירות ביקורים:"
    },
    "homeAdvice": {
      "title": "ייעוץ לבית",
      "do": "מומלץ",
      "avoid": "יש להימנע"
    },
    "redFlags": {
      "title": "מתי לפנות אלינו או לרופא הילדים",
      "urgentTitle": "פנו לטיפול רפואי דחוף אם {{child}}:",
      "temperature": "חום מעל 38°C (מתחת לגיל 3 חודשים) או 39°C (מעל 3 חודשים)",
      "floppy": "רפוי/ה באופן חריג, ישנוני/ת או לא מגיב/ה",
      "vomiting": "הקאות בזרם חזק או הקאות המכילות מרה ירוקה",
      "refusesFeeds": "מסרב/ת לכל ההאכלות למשך יותר מ-4–6 שעות",
      "fontanelle": "המפתח (נקודה רכה) בולט",
      "seizure": "פרכוסים או תנועות חריגות",
      "soonerTitle": "קבעו תור מוקדם יותר אם:",
      "notImproving": "מצבו/ה של {{child}} לא נראה משתפר",
      "newSymptoms": "מתפתחים תסמינים חדשים שמדאיגים אתכם",
      "changeMovement": "אתם מבחינים בשינוי בתנועה או בהתנהגות {{possessive}}",
      "questionsWorries": "יש לכם שאלות או דאגות בין הביקורים"
    },
    "parentNote": {
      "title": "הערה להורים",
      "bodyWithConditions": "אנו מבינים שהערכת תינוק יכולה להיות חוויה מלחיצה. אנא דעו שמצבו/ה של {{child}} נפוץ מאוד ומגיב היטב לטיפול ולייעוץ שפירטנו. תינוקות ניחנים ביכולת הסתגלות מדהימה, ועם האהבה שלכם וההנחיה הנכונה, רוב הבעיות השריריות-שלדיות בינקות נפתרות יפה. אתם עושים עבודה מצוינת כהורים.",
      "bodyNoConditions": "אנו מבינים שהערכת תינוק יכולה להיות חוויה מלחיצה. אנא דעו שהתפתחותו/ה של {{child}} נראית בריאה ואנחנו כאן לתמוך בכם בכל שאלה. תינוקות ניחנים ביכולת הסתגלות מדהימה, ועם האהבה שלכם וההנחיה הנכונה, רוב הבעיות השריריות-שלדיות בינקות נפתרות יפה. אתם עושים עבודה מצוינת כהורים.",
      "contactUs": "אם יהיו לכם שאלות בין הפגישות, אנא אל תהססו לפנות אלינו. אין שאלה קטנה מדי או טיפשית — תמיד נעדיף שתשאלו במקום שתדאגו."
    },
    "nextSteps": {
      "title": "הצעדים הבאים",
      "withFrequency": "אנו ממליצים לראות את {{child}} שוב {{frequency}}.",
      "withoutFrequency": "נקבע את הביקור הבא של {{child}} בהתאם להתקדמות {{possessive}}.",
      "bookingIntro": "לקביעת התור הבא או אם יש לכם שאלות, אנא צרו קשר:",
      "scanToBook": "סרקו לקביעת תור"
    }
  },
  "exerciseProgram": {
    "title": "תוכנית תרגילים",
    "homeTitle": "תוכנית תרגילים לבית",
    "generated": "נוצר",
    "noProgram": "טרם נוצרה תוכנית תרגילים. לחצו על \"יצירת תוכנית\" ליצירת תוכנית מותאמת אישית.",
    "generatePlan": "יצירת תוכנית תרגילים",
    "regenerate": "יצירה מחדש",
    "generating": "יוצר...",
    "downloading": "מוריד...",
    "downloadPdf": "הורדת PDF",
    "generateFailed": "יצירת תוכנית התרגילים נכשלה",
    "pdfFailed": "יצירת PDF התרגילים נכשלה",
    "pdfDownloadFailed": "הורדת ה-PDF נכשלה",
    "contraindicationWarnings": "אזהרות התוויות נגד",
    "sets": "סטים",
    "reps": "חזרות",
    "hold": "החזקה",
    "instructions": "הוראות",
    "guidedExercise": "תרגיל מודרך",
    "completed": "הושלם",
    "guidedResults": "תוצאות תרגילים מודרכים",
    "totalExercises": "סה\"כ תרגילים",
    "regions": "אזורים"
  },
  "consent": {
    "title": "ניהול הסכמות",
    "loadingConsents": "טוען הסכמות...",
    "noData": "אין נתוני הסכמה זמינים.",
    "viewHistory": "הצג היסטוריה",
    "hideHistory": "הסתר היסטוריה",
    "viewText": "הצג טקסט",
    "hideText": "הסתר טקסט",
    "signConsent": "חתימה על הסכמה",
    "signing": "חותם...",
    "revoke": "ביטול",
    "revoking": "מבטל...",
    "signed": "נחתם",
    "revoked": "בוטל",
    "consentText": "טקסט ההסכמה",
    "history": "היסטוריית הסכמות",
    "noHistory": "אין רשומות היסטוריה.",
    "actionSigned": "נחתם",
    "actionRevoked": "בוטל",
    "by": "על ידי",
    "status": {
      "active": "פעיל",
      "not_signed": "לא נחתם",
      "revoked": "בוטל"
    }
  },
  "imaging": {
    "title": "העלאת דימות",
    "dismiss": "סגור",
    "dragDrop": "גררו ושחררו קבצים כאן, או",
    "browseFiles": "עיינו בקבצים",
    "acceptedFormats": "JPEG, PNG, PDF עד 10MB כל אחד",
    "uploading": "מעלה...",
    "uploadedFiles": "קבצים שהועלו",
    "uploaded": "הועלה",
    "analyzeWithAI": "ניתוח באמצעות AI",
    "analyzing": "AI מנתח...",
    "aiAnalysisResults": "תוצאות ניתוח AI",
    "aiAssistedObservation": "תצפית בסיוע AI — נדרש אימות רופא",
    "analyzed": "נותח",
    "findingsNotConfirmed": "הממצאים אינם מאושרים עד שתאמתו כל אחד מהם",
    "findings": "ממצאי הדמיה",
    "measurements": "מדידות",
    "impressions": "התרשמויות",
    "normal": "תקין",
    "reject": "דחייה",
    "review": "סקירת הדמיה",
    "comparison": "השוואת הדמיה",
    "overallChange": "שינוי כולל",
    "improved": "שיפור",
    "stable": "יציב",
    "progressed": "התקדם",
    "aiAssisted": "ניתוח בסיוע בינה מלאכותית — נבדק ואושר על ידי המטפל",
    "analyzeButton": "ניתוח עם AI",
    "uploadImage": "העלאת תמונה",
    "compareButton": "השוואת תמונות",
    "dateTaken": "תאריך צילום",
    "viewSequence": "תצוגה / רצף"
  },
  "labResults": {
    "title": "תוצאות מעבדה",
    "valuePlaceholder": "ערך",
    "normal": "תקין",
    "autoInterpretation": "פרשנות אוטומטית",
    "savedSuccessfully": "נשמר בהצלחה",
    "saveResults": "שמירת תוצאות"
  },
  "copilot": {
    "aggravating": "מחמירים",
    "analyze": "נתח עם AI",
    "analyzing": "מנתח תיאור...",
    "carePhase": "שלב טיפול מומלץ",
    "clarification": "ה-AI צריך הבהרה",
    "close": "סגור",
    "complaints": "תלונות",
    "confidence": "ביטחון",
    "diagnoses": "אבחנות",
    "expected": "צפוי",
    "followUp": "מעקב",
    "functionalChanges": "שינויים תפקודיים",
    "initial": "ראשוני",
    "initialExam": "בדיקה ראשונית",
    "language": "שפה",
    "listening": "מקשיב...",
    "loadingTests": "מקבל המלצות בדיקות...",
    "newComplaints": "תלונות חדשות",
    "painComparison": "השוואת כאב",
    "parsedFindings": "ממצאי AI",
    "planUpdates": "עדכוני תוכנית",
    "previousNarrative": "תיאור קודם:",
    "proceedToTests": "המשך לבדיקה פיזית →",
    "progressSummary": "סיכום התקדמות",
    "reExamComplete": "בדיקה חוזרת הושלמה",
    "reExamSaved": "כל הנתונים נשמרו.",
    "redFlags": "דגלים אדומים שזוהו",
    "relieving": "מקלים",
    "resolved": "נפתר",
    "saveComplete": "שמור וסיים",
    "saving": "שומר...",
    "startReExam": "התחל בדיקה חוזרת AI",
    "startVoice": "התחל קלט קולי",
    "starting": "מתחיל...",
    "stop": "עצור",
    "stopVoice": "עצור",
    "submitClarification": "שלח ונתח מחדש",
    "submitResults": "שלח ועדכן DDx",
    "subtitle": "בדיקה חוזרת",
    "testRationale": "למה בדיקות אלו?",
    "testResults": "תוצאות בדיקות",
    "tests": "בדיקות",
    "title": "עוזר קליני AI",
    "typeAnswer": "הקלד את תשובתך...",
    "updatedDiagnoses": "אבחנות מעודכנות",
    "updatingDdx": "מעדכן אבחנה...",
    "voiceNotSupported": "קלט קולי לא זמין. הקלד את ההערות שלך.",
    "wellnessScores": "ציוני בריאות"
  },
  "email": {
    "attachPdf": "צרף דוח PDF",
    "cancel": "ביטול",
    "language": "שפת הדוח",
    "patientEmail": "אימייל מטופל",
    "send": "שלח",
    "sendReport": "שלח דוח",
    "sending": "שולח...",
    "templatePreview": "תצוגה מקדימה של תבנית"
  },
  "exercises": {
    "title": "תכנית תרגילים",
    "current": "תרגילים נוכחיים",
    "history": "היסטוריית תרגילים",
    "addExercise": "הוסף תרגיל",
    "recommended": "מומלצים",
    "progress": "התקדם",
    "pause": "השהה",
    "resume": "חדש",
    "remove": "הסר",
    "logSession": "רשום",
    "logAll": "רשום הכל",
    "printSheet": "הדפס",
    "adherence": "הקפדה",
    "excellent": "מצוין",
    "good": "טוב",
    "needsImprovement": "דרוש שיפור",
    "atRisk": "בסיכון",
    "setsCompleted": "סטים",
    "repsCompleted": "חזרות",
    "painDuring": "כאב במהלך",
    "painAfter": "כאב אחרי",
    "difficulty": "קושי",
    "tooEasy": "קל מדי",
    "justRight": "בדיוק נכון",
    "tooHard": "קשה מדי",
    "level1": "מתחיל",
    "level2": "בינוני",
    "level3": "מתקדם",
    "level4": "אתלטי",
    "level5": "עילית",
    "activeCare": "טיפול פעיל",
    "correctiveCare": "שיקום",
    "maintenance": "תחזוקה",
    "myObligations": "הגוף שלי החובות שלי",
    "allDoneToday": "הכל בוצע להיום!",
    "keepGoing": "המשיכו!",
    "greatConsistency": "עקביות מצוינת!",
    "sets": "סטים",
    "reps": "חזרות",
    "hold": "החזקה",
    "rest": "מנוחה",
    "frequency": "תדירות",
    "perWeek": "בשבוע",
    "equipment": "ציוד",
    "formCheckpoints": "נקודות ביקורת",
    "contraindications": "התוויות נגד",
    "progressionCriteria": "קריטריונים להתקדמות",
    "prescribedDate": "נרשם",
    "expiresDate": "פג תוקף",
    "supersededBy": "הוחלף על ידי",
    "noExercises": "לא נרשמו תרגילים",
    "addFromLibrary": "הוסף מהספרייה",
    "confirmRemove": "להסיר תרגיל זה?",
    "progressTo": "עבור לשלב הבא",
    "exerciseLibrary": "ספריית תרגילים",
    "filterByRegion": "סנן לפי אזור",
    "filterByLevel": "סנן לפי רמה",
    "filterByCategory": "סנן לפי קטגוריה",
    "addToPlan": "הוסף לתכנית",
    "phase": "שלב",
    "notes": "הערות",
    "allLevels": "כל הרמות",
    "allCategories": "כל הקטגוריות",
    "allRegions": "כל האזורים",
    "xTimesPerWeek": "{{count}}x בשבוע",
    "painScale": "כאב (0-10)",
    "streakDays": "ימים רצופים",
    "loggedToday": "נרשם היום",
    "noData": "אין נתונים",
    "thisWeek": "השבוע",
    "none": "עדיין לא נקבעו תרגילים.",
    "doWithCamera": "עם מצלמה",
    "markDone": "בוצע",
    "start": "התחלה",
    "cancel": "ביטול",
    "finish": "סיום",
    "setDone": "סט הושלם",
    "nextSet": "הסט הבא בעוד",
    "formScore": "איכות ביצוע",
    "allDone": "הכל בוצע!",
    "voice": {
      "begin": "התחילו את התרגיל עכשיו"
    },
    "feedback": {
      "great": "ביצוע מצוין!",
      "good": "טוב, נסו לרדת קצת יותר",
      "watch": "שימו לב לביצוע — טווח תנועה מלא",
      "excellent": "מעולה!"
    }
  },
  "funcMovement": {
    "accept": "אשר",
    "aiSummary": "סיכום קליני AI",
    "analyzing": "מנתח תנועה...",
    "back": "חזור",
    "categoryBreakdown": "פירוט קטגוריות",
    "generateReport": "צור דוח",
    "overallScore": "ציון כללי",
    "patientReady": "מטופל מוכן",
    "quickScreen": "סינון מהיר (~3 דק)",
    "readToPatient": "קרא למטופל:",
    "recommendations": "המלצות",
    "redo": "חזור על",
    "result": "תוצאה",
    "setupInstructions": "מקם את המכשיר על משטח יציב, 2 מטרים מהמטופל",
    "skip": "דלג",
    "startTest": "התחל בדיקה",
    "stopCapture": "עצור",
    "title": "הערכת תנועה תפקודית"
  },
  "gamification": {
    "achievements": "הישגים",
    "balance": "שיווי משקל",
    "best": "הטוב ביותר",
    "bodyPerformance": "ציון ביצועי הגוף",
    "change": "שינוי",
    "completedExercises": "תרגילים שהושלמו",
    "converted": "הצטרף",
    "copied": "הועתק! שתף עם חברים",
    "current": "נוכחי",
    "dailyCheckIn": "צ׳ק-אין יומי",
    "dayStreak": "ימים ברצף",
    "days": "ימים",
    "energyLevel": "רמת אנרגיה",
    "howDidYouMove": "איך זזת היום?",
    "initial": "ראשוני",
    "lifestyle": "אורח חיים",
    "movement": "תנועה",
    "nextTier": "הבא",
    "noAchievementsInCategory": "אין הישגים בקטגוריה זו",
    "noStreaks": "התחל את הרצף הראשון שלך היום!",
    "nowScore": "עכשיו",
    "pending": "ממתין",
    "personalBest": "שיא חדש!",
    "progressSnapshot": "ההתקדמות שלך",
    "recovery": "התאוששות",
    "referralMessage": "אני ממליץ על",
    "referralProgram": "תוכנית הפניות",
    "referralUseCode": "השתמש בקוד שלי",
    "retry": "נסה שוב",
    "shareCode": "העתק ושתף",
    "sleepQuality": "איכות שינה",
    "sortCategory": "מיין לפי קטגוריה",
    "sortRecent": "מיין לפי אחרונים",
    "startScore": "התחלה",
    "streaks": "הרצפים שלך",
    "strength": "כוח",
    "stressLevel": "רמת לחץ (1=נמוך, 5=גבוה)",
    "submitCheckIn": "שלח צ׳ק-אין",
    "submitting": "שולח...",
    "total": "סה״כ",
    "visits": "ביקורים",
    "yourCode": "קוד ההפניה שלך"
  },
  "lifestyle": {
    "activity": "פעילות גופנית",
    "alcohol": "צריכת אלכוהול?",
    "answered": "הושבו",
    "breaks": "הפסקות קבועות?",
    "diet": "תאר את התזונה שלך?",
    "ergonomics": "עבודה וארגונומיה",
    "exerciseFreq": "באיזו תדירות אתה מתאמן?",
    "exerciseTypes": "איזה סוג?",
    "habits": "הרגלים",
    "howActive": "כמה אתה פעיל?",
    "nutrition": "תזונה ושתייה",
    "occupation": "רמת פעילות יומית?",
    "quickMode": "← מצב מהיר",
    "quickTitle": "בדיקת אורח חיים מהירה",
    "saving": "שומר...",
    "sitting": "שעות ישיבה ביום?",
    "sittingQ": "שעות ישיבה?",
    "sleep": "שינה",
    "sleepHours": "שעות בלילה?",
    "sleepQ": "איכות שינה?",
    "sleepQuality": "איכות שינה?",
    "smoking": "אתה מעשן?",
    "stress": "לחץ",
    "stressLevel": "רמת לחץ?",
    "stressQ": "רמת לחץ?",
    "stressSources": "מקורות עיקריים?",
    "title": "ציון אורח חיים",
    "wantMore": "רוצה יותר פרטים? הרחב הערכה מלאה →",
    "water": "כוסות מים ביום?"
  },
  "notifications": {
    "empty": "אין התראות",
    "markAllRead": "סמן הכל כנקרא",
    "title": "התראות"
  },
  "painMap": {
    "back": "אחורי",
    "clearView": "נקה",
    "front": "קדמי",
    "instruction": "לחץ על הגוף לסימון מיקומי כאב",
    "markers": "סימנים",
    "title": "סימון מיקום כאב",
    "undo": "בטל"
  },
  "planner": {
    "headers": {
      "phase": "שלב",
      "frequency": "תדירות",
      "duration": "משך (שבועות)",
      "action": "פעולה"
    },
    "totalVisits": "סך ביקורים לפני טיפול תחזוקה: {{count}}"
  },
  "portal": {
    "achievements": "ההישגים שלך",
    "balance": "שיווי משקל",
    "bodyPerformance": "ביצועי הגוף שלך",
    "breakdown": "פירוט ציונים",
    "calmToStressed": "רגוע → לחוץ",
    "checkedIn": "נרשמת היום!",
    "codeHint": "בדוק את הדוח שלך או שאל בקבלה",
    "copied": "הועתק!",
    "copyShare": "העתק ושתף",
    "dailyQuote": "כל צעד קדימה מחזק אותך.",
    "dayStreak": "ימים ברצף",
    "didExercises": "עשית את התרגילים?",
    "doneToday": "היום",
    "download": "הורד",
    "earned": "הרווחת",
    "energyLevel": "רמת אנרגיה?",
    "enterCode": "הזן את קוד הגישה שלך",
    "estimatedNext": "ביקור הבא",
    "exercises": "תרגילים",
    "faq": "שאלות נפוצות",
    "faqAfterPain": "מה אחרי שהכאב עובר?",
    "faqAfterPainA": "מעבר לטיפול הרווחה.",
    "faqFreqActive": "בשלב טיפול הקלה — 2 ביקורים בשבוע.",
    "faqFreqMaint": "כרגע מספיקים ביקורים חודשיים.",
    "faqFrequency": "כמה פעמים לבוא?",
    "faqScoring": "איך עובד הציון?",
    "faqScoringA": "הציון מודד 5 תחומים: תנועה, כוח, שיווי משקל, התאוששות, אורח חיים.",
    "faqWhenBetter": "מתי ירגיש יותר טוב?",
    "faqWhenBetterA": "רוב המטופלים מרגישים שיפור תוך 2-4 שבועות.",
    "firstVisit": "ביקור ראשון",
    "friendsJoined": "חברים הצטרפו",
    "health": "בריאות",
    "howFeeling": "איך אתה מרגיש היום?",
    "howMove": "איך זזת היום?",
    "invalidCode": "קוד לא תקין.",
    "journeyTimeline": "המסע שלך",
    "lifestyle": "אורח חיים",
    "movement": "תנועה",
    "myExercises": "התרגילים שלי",
    "myReports": "הדוחות שלי",
    "needHelp": "צריך עזרה? פנה למרפאה",
    "networkError": "שגיאת חיבור.",
    "next": "הבא",
    "nextVisit": "ביקור הבא",
    "no": "לא",
    "noAchievementsYet": "בצע צ׳ק-אין יומי לקבלת תגים!",
    "noExercises": "עדיין לא נקבעו תרגילים.",
    "noProgress": "יש להשלים לפחות שתי הערכות כדי לראות את ההתקדמות.",
    "noReferral": "בקש קוד מהמרפאה.",
    "noReports": "אין דוחות עדיין.",
    "now": "עכשיו",
    "personalBest": "שיא חדש!",
    "personalizedTips": "תוכנית השיפור שלך",
    "pointsImproved": "נקודות שיפור",
    "recovery": "התאוששות",
    "refer": "הפנה",
    "referralMsg": "אני ממליץ על",
    "reports": "דוחות",
    "seeFullProgress": "ראה התקדמות מלאה →",
    "shareWellness": "שתף את מסע הבריאות!",
    "sinceLast": "מהביקור האחרון",
    "sleepQuality": "איך ישנת?",
    "startStreak": "התחל היום!",
    "strength": "כוח",
    "stressLevel": "רמת לחץ?",
    "totalShares": "סה״כ שיתופים",
    "treatmentGoals": "המטרות שלך",
    "useCode": "השתמש בקוד",
    "verifying": "מאמת...",
    "viewAll": "הכל →",
    "viewCarePlan": "תוכנית טיפול →",
    "viewDashboard": "לוח בקרה",
    "welcome": "ברוך הבא",
    "yes": "כן",
    "yourCarePlan": "תוכנית הטיפול שלך",
    "yourJourney": "מסע הבריאות שלך",
    "yourProgress": "ההתקדמות שלך",
    "yourReferralCode": "קוד ההפניה שלך",
    "hiName": "היי {{name}}!",
    "stageRelief": "טיפול הקלה",
    "stageRehab": "שיקום",
    "stageWellness": "טיפול הרווחה"
  },
  "portalAdmin": {
    "accessCode": "קוד גישה",
    "generate": "צור קוד",
    "generating": "יוצר...",
    "noAccess": "עדיין לא הוגדרה גישה",
    "patientPortal": "גישה לפורטל מטופל"
  },
  "save": {
    "ago": "לפני",
    "justNow": "הרגע",
    "saveDraft": "שמור טיוטה",
    "saveExit": "שמור וצא",
    "saved": "נשמר",
    "saving": "שומר...",
    "unsaved": "שינויים לא שמורים",
    "upToDate": "מעודכן"
  },
  "screening": {
    "alerts": "התראות סינון קליניות",
    "bpHeadache": "מומלץ מדידת לחץ דם בהצגת כאב ראש.",
    "bpRecommended": "מומלץ מדידת לחץ דם",
    "cnHeadache": "מטופל עם כאב ראש. מומלצת הערכת עצבים קרניאליים.",
    "cnNeuro": "מומלץ סינון נוירולוגי",
    "cnNeuroReason": "תלונה צווארית עם תסמינים נוירולוגיים.",
    "cnRecommended": "מומלץ בדיקת עצבים קרניאליים",
    "save": "שמור",
    "saveResults": "שמור תוצאות",
    "vbiReason": "תלונה צווארית עם סחרחורת. נדרש VBI לפני מניפולציה.",
    "vbiRequired": "נדרש סינון עורק חולייתי"
  },
  "softTissue": {
    "confirmWith": "אשר עם",
    "more": "עוד זמינים",
    "noStructures": "לא נטענו מבנים עבור האזורים שנבחרו.",
    "palpation": "מדריך מישוש",
    "showLess": "← הצג רק 3",
    "significance": "משמעות קלינית",
    "title": "הערכת רקמות רכות",
    "top3": "מוביל 3"
  },
  "uploads": {
    "addToFile": "הוסף לתיק הבריאות",
    "description": "תיאור (אופציונלי)",
    "logToday": "רשום היום",
    "myUploads": "הקבצים שלי",
    "trackBody": "מעקב גוף",
    "upload": "העלה",
    "uploading": "מעלה..."
  },
  "intake": {
    "loading": "טוען...",
    "oops": "אופס",
    "noToken": "לא סופק קוד גישה.",
    "linkExpired": "הקישור פג תוקף. אנא צרו קשר עם המרפאה.",
    "invalidLink": "קישור לא תקין. אנא צרו קשר עם המרפאה.",
    "somethingWrong": "משהו השתבש.",
    "unableToConnect": "לא ניתן להתחבר. בדקו את החיבור לאינטרנט."
  },
  "onboarding": {
    "stepOf": "שלב {{current}} מתוך {{total}}",
    "finishLater": "אסיים מאוחר יותר",
    "back": "חזרה",
    "next": "הבא",
    "completeSetup": "השלמת ההגדרה",
    "welcome": {
      "title": "ברוכים הבאים ל-MSK Insight",
      "subtitle": "בואו נגדיר את המרפאה שלכם בכ-5 דקות. תוכלו לשנות הכול מאוחר יותר בהגדרות.",
      "clinicTypePrompt": "מה סוג המרפאה שלכם?",
      "getStarted": "התחל"
    },
    "clinicIdentity": {
      "title": "זהות המרפאה",
      "subtitle": "מידע בסיסי על המרפאה שלכם.",
      "clinicName": "שם המרפאה",
      "phone": "טלפון",
      "email": "אימייל",
      "address": "כתובת",
      "whatsapp": "וואטסאפ",
      "website": "אתר אינטרנט",
      "placeholderName": "לדוגמה: מרכז הכירופרקטיקה",
      "placeholderPhone": "+357 25 344747",
      "placeholderEmail": "info@yourclinic.com",
      "placeholderAddress": "שדרות מקריוס 25, 3040 לימסול, קפריסין",
      "placeholderWhatsapp": "+357 99 123456",
      "placeholderWebsite": "https://yourclinic.com",
      "errorClinicName": "שם המרפאה נדרש",
      "errorPhone": "מספר טלפון נדרש",
      "errorEmail": "אימייל נדרש"
    },
    "team": {
      "title": "הצוות שלכם",
      "subtitle": "מי עובד במרפאה שלכם? תוכלו להוסיף חברי צוות מאוחר יותר.",
      "lead": "מנהל",
      "fullName": "שם מלא",
      "roleTitle": "תפקיד / כותרת",
      "credential": "הסמכה מקצועית",
      "bio": "ביוגרפיה קצרה",
      "bioPlaceholder": "ביוגרפיה מקצועית קצרה (אופציונלי)",
      "leadOwner": "מנהל / בעלים קליני",
      "add": "הוסף",
      "save": "שמור",
      "cancel": "ביטול",
      "addTeamMember": "+ הוסף חבר צוות",
      "select": "-- בחר --",
      "placeholderName": "לדוגמה: מריה גיאורגיו",
      "placeholderTitle": "לדוגמה: כירופרקט ראשי"
    },
    "modalities": {
      "title": "שיטות קליניות",
      "subtitle": "אילו טיפולים המרפאה שלכם מציעה? המלצות AI יוגבלו לאלה."
    },
    "assessmentTools": {
      "title": "כלי הערכה",
      "subtitle": "באילו כלי אבחון אתם משתמשים? ניתן לדלג על שלב זה."
    },
    "carePathway": {
      "title": "מסלול טיפול",
      "subtitle": "כיצד אתם מבנים את הטיפול בחולים? מולא מראש לפי סוג המרפאה."
    },
    "reportPreferences": {
      "title": "העדפות דוחות",
      "subtitle": "כיצד צריכים להיראות דוחות מטופלים ומכתבי GP?"
    },
    "integrations": {
      "title": "אינטגרציות",
      "subtitle": "חברו את הכלים הקיימים שלכם. ניתן להגדיר מאוחר יותר.",
      "practiceHub": "PracticeHub",
      "practiceHubDesc": "סנכרון תורים ונתוני מטופלים",
      "emailSmtp": "אימייל (SMTP)",
      "emailSmtpDesc": "שליחת דוחות ותזכורות למטופלים",
      "aiAssistant": "עוזר AI",
      "aiAssistantDesc": "נרטיבי דוחות ותובנות קליניות מבוססות AI",
      "configureAfter": "הגדירו בהגדרות → אינטגרציות לאחר ההתקנה.",
      "allOptional": "כל האינטגרציות אופציונליות וניתנות להגדרה בכל עת."
    },
    "review": {
      "title": "סקרו את ההגדרה",
      "subtitle": "הכול נראה טוב? תוכלו לשנות הכול מאוחר יותר בהגדרות.",
      "clinicIdentity": "זהות המרפאה",
      "yourTeam": "הצוות שלכם",
      "clinicalModalities": "שיטות קליניות",
      "assessmentTools": "כלי הערכה",
      "carePathway": "מסלול טיפול",
      "reportPreferences": "העדפות דוחות",
      "clinicType": "סוג מרפאה",
      "edit": "עריכה",
      "notConfigured": "טרם הוגדר",
      "name": "שם",
      "phone": "טלפון",
      "email": "אימייל",
      "address": "כתובת",
      "languages": "שפות",
      "notSet": "לא הוגדר"
    },
    "completion": {
      "title": "המרפאה שלכם מוכנה!",
      "subtitle": "הכול מוגדר. תוכלו להתחיל לקבל מטופלים מיד או להתאים אישית בהגדרות.",
      "addFirstPatient": "הוסף מטופל ראשון",
      "exploreDashboard": "סקור את לוח הבקרה",
      "customiseSettings": "התאם הגדרות",
      "redirecting": "מפנה ללוח הבקרה בעוד {{seconds}} שניות..."
    }
  },
  "session": {
    "warning": {
      "message": "ההפעלה שלך תסתיים בעוד 5 דקות. לחץ כדי להישאר מחובר.",
      "button": "הישאר מחובר"
    },
    "expired": {
      "toast": "ההפעלה שלך פגה. אנא היכנס שוב."
    }
  },
  "reportV2": {
    "rv2CoverTitle": "תוכנית ההחלמה והביצועים האישית שלך",
    "rv2PreparedFor": "הוכן עבור **{patient_full_name}** · {report_date}",
    "rv2ToldLabel": "מה סיפרת לנו",
    "rv2GoalsLabel": "מה תרצה להחזיר לעצמך",
    "rv2WhatItMeansLabel": "מה זה אומר:",
    "rv2ContributingLabel": "אזורים תורמים:",
    "rv2HowWeCanHelpLabel": "איך נוכל לעזור",
    "rv2AlsoCovered": "מכוסה גם בתוכנית שלך",
    "rv2RecoveryDialTitle": "ציון ההחלמה שלך",
    "rv2ProgressHeading": "ההתקדמות שלך מאז הביקור האחרון",
    "rv2ScheduleHeading": "לוח הטיפולים שלך",
    "rv2ScheduleFootnote": "פרוטוקולי הטיפול נבדקים מול העדויות הקליניות העדכניות ביותר.",
    "rv2BookingDatesNote": "מועדי התורים בפועל עשויים להשתנות מעט בהתאם לזמינות ביומן.",
    "rv2Ongoing": "מתמשך",
    "rv2CarePlanHeading": "תוכנית הטיפול האישית שלך",
    "rv2HomeAdviceHeading": "תוכנית הטיפול הביתי שלך",
    "rv2ColDoNow": "לעשות עכשיו",
    "rv2ColAvoid": "ממה להימנע",
    "rv2ColLifestyle": "שינויים באורח החיים",
    "rv2ColSupplement": "תוסף",
    "rv2ColDosage": "מינון",
    "rv2ColWhen": "מתי ליטול",
    "rv2ColWhatItDoes": "מה הוא עושה",
    "rv2AsDirected": "לפי ההנחיות",
    "rv2SupportsRecovery": "תומך בהחלמה וברווחה",
    "rv2Daily": "מדי יום",
    "rv2QrCaption": "סרקו לקביעת תור אונליין",
    "rv2ContentsStory": "הסיפור שלך",
    "rv2ContentsFound": "מה מצאנו",
    "rv2ContentsCarePlan": "תוכנית הטיפול שלך",
    "rv2ContentsNext": "הצעדים הבאים",
    "rv2Call": "התקשרו",
    "rv2Online": "אונליין",
    "rv2Page": "עמוד",
    "rv2PainRatingLabel": "דירוג הכאב שלך",
    "rv2NotRecorded": "לא תועד בביקור זה",
    "rv2OpeningHours": "שעות פעילות:",
    "rv2GoalsTarget": "זו המטרה המשותפת שלנו, והתוכנית שלמטה בנויה כדי להביא אותך אליה.",
    "rv2HowWeCanHelpText": "טיפול שמטרתו להרגיע את הרקמה המגורה, לשחזר את התנועה והכוח שמגנים עליה ולעזור לך להישאר בכושר טוב לאורך זמן.",
    "rv2GoldenIntro": "אלה הדברים העיקריים שכדאי לזכור בין הפגישות. הקפדה על ההנחיות האלה תעזור לך להפיק את המרב מהטיפול.",
    "rv2ExerciseNote": "התרגילים שמוצגים או נידונים הם דוגמאות בלבד. מומחה השיקום שלך יקבע עבורך את התרגילים המתאימים לך בשלב הנכון של הטיפול.",
    "rv2TroublingFor": "מטריד אותך כבר",
    "rv2ByYourChiropractor": "הכירופרקט שלך {name} ({credential})",
    "rv2WhyLabel": "למה אנחנו עושים את זה",
    "rv2WhyText": "ב The Chiropractic Center בנינו צוות רב תחומי, מונע טכנולוגיה וממוקד באנשים, עם תפקיד אחד: לעזור לך ולהעצים אותך להשיג את המטרות שלך. אנחנו מחפשים את הסיבה האמיתית, בונים מחדש את מה שהגוף שלך צריך, ומחזירים לך את הבעלות על הבריאות שלך. וכשתהיה מוכן ליותר מהחלמה, טיפול ובריאות לכל החיים מחכים לך. תמיד הבחירה שלך, תמיד הקצב שלך.",
    "rv2JourneyCaption": "להרגיע · לבנות מחדש · לשמור לכל החיים",
    "rv2JourneyChoice": "השלב השלישי הוא הזמנה. תמיד הבחירה שלך.",
    "rv2WhatItMeansFallback": "המבנים באזור הזה מגורים ואינם מקבלים תמיכה מספקת, ותוכנית ממוקדת ומדורגת מתאימה היטב להתמודדות עם מצב כזה",
    "rv2PageOf": "מתוך"
  },
  "versionNudge": {
    "message": "קיימת גרסה חדשה",
    "reload": "רענון",
    "later": "מאוחר יותר"
  },
  "autosave": {
    "finalizedNothingToSave": "ההערכה הושלמה. אין עוד מה לשמור.",
    "finalizedShort": "הושלמה"
  },
  "reportGenerator": {
    "emailNotEnabled": "שליחת אימייל עדיין לא הופעלה עבור מרפאה זו. בקשו מהמנהל להגדיר אותה.",
    "emailNeedsFinalize": "סיימו את ההערכה לפני שליחת הדוח למטופל באימייל."
  },
  "amend": {
    "inProgressTitle": "תיקון בתהליך",
    "inProgressBody": "גרסה {{version}} נשארת פעילה וללא שינוי עד שתלחצו על סיום, שמפרסם את גרסה {{next}}.",
    "button": "תיקון הדוח",
    "reopening": "פותח מחדש...",
    "buttonHint": "פתחו מחדש דוח שהונפק כדי לפרסם גרסה מתוקנת",
    "currentVersion": "גרסה נוכחית: {{version}}",
    "failed": "לא ניתן היה לפתוח את הדוח לתיקון."
  },
  "pushStatus": {
    "delivered": "נשלח ל-PracticeHub v{{version}}",
    "retrying": "PracticeHub: ניסיון חוזר ב-{{time}}",
    "failed": "PracticeHub: לא נשלח לאחר {{attempts}} ניסיונות",
    "pushNow": "שלח עכשיו",
    "pushing": "שולח…"
  },
  "lifecycle": {
    "draft": "טיוטה",
    "confirmedNotIssued": "אושר — טרם הונפק",
    "amending": "תיקון בתהליך",
    "issued": "הונפק v{{version}}"
  },
  "sprint6": {
    "journeyWeekByWeek": "שבוע אחר שבוע",
    "journeyWeekLabel": "שבוע {{n}}",
    "journeyAnd": "וגם",
    "journeyOr": "או",
    "journeyWith": "עם",
    "journeyGapWeek": "אין ביקור השבוע",
    "journeyChoiceNote": "כשמופיעים שני שמות, נאשר את מי תפגשו בעת קביעת הביקור.",
    "journeyThenMaintenance": "לאחר מכן Wellness Care כל 6 שבועות",
    "journeyPractitionerColumn": "מטפל/ת"
  },
  "letterMachine": {
    "title": "יצירת מכתב",
    "letterType": "סוג המכתב",
    "typeReferral": "הפניה",
    "typeProgress": "מעקב",
    "typeInsurance": "ביטוח",
    "recipient": "נמען",
    "recipientHintReferral": "לדוגמה, ״ד״ר ג׳יין סמית׳״",
    "recipientHintProgress": "לדוגמה, ״ד״ר ג׳יין סמית׳״ (או להשאיר ריק עבור הרשומה הרפואית של המטופל)",
    "recipientHintInsurance": "לדוגמה, שם חברת הביטוח, או להשאיר ריק עבור ״לכל מאן דבעי״",
    "policyRef": "מספר פוליסה / תביעה (לא חובה)",
    "generate": "יצירה",
    "regenerate": "יצירה מחדש",
    "generating": "יוצר…",
    "editableDraft": "טיוטה ניתנת לעריכה",
    "editsNote": "השינויים כאן ייכללו בהעתקה, בהורדה, בהעברה ל-PracticeHub ובשליחה בדוא״ל.",
    "copy": "העתקה",
    "copied": "המכתב הועתק ללוח",
    "copyFailed": "ההעתקה נכשלה — יש לבחור ולהעתיק ידנית",
    "downloadPdf": "הורדת PDF",
    "rendering": "מכין…",
    "pushToPracticeHub": "העברה ל-PracticeHub",
    "pushing": "מעביר…",
    "emailToPatient": "שליחה למטופל בדוא״ל",
    "sending": "שולח…",
    "englishOnly": "המכתבים מופקים באנגלית.",
    "requests": "בקשות",
    "requestsIntro": "סמנו מה ברצונכם לבקש. השורות המוצעות מבוססות על סימני אזהרה ועל השערת העבודה; בטלו את הסימון של כל מה שאינו רצוי.",
    "addRequest": "הוספת בקשה",
    "noRequests": "לא נבחר דבר: המכתב יכלול עדכון קליני בלבד.",
    "loadingSuggestions": "טוען הצעות…",
    "kind": "סוג",
    "kindImaging": "דימות",
    "kindOpinion": "חוות דעת מומחה",
    "kindEmergency": "מסלול חירום",
    "kindUpdateOnly": "עדכון קליני בלבד",
    "modality": "שיטת דימות",
    "specialty": "תחום התמחות",
    "region": "אזור",
    "purpose": "מטרה",
    "purposeCustom": "מטרה אחרת (הקלידו)",
    "urgency": "דחיפות",
    "urgencyRoutine": "שגרתי",
    "urgencySoon": "בהקדם",
    "urgencyUrgent": "דחוף",
    "urgencyEmergency": "חירום",
    "suggested": "מוצע",
    "fromRedFlag": "על סמך סימן אזהרה",
    "fromHypothesis": "על סמך השערת העבודה",
    "remove": "הסרה",
    "moveUp": "העברה למעלה",
    "moveDown": "העברה למטה",
    "regionNone": "ללא אזור"
  },
  "phV3": {
    "title": "PracticeHub v3 (ה-API החדש)",
    "intro": "למעבר ל-API החדש של PracticeHub. עדיין לא בשימוש: כל משאב למטה נשאר בחיבור הישן עד הבדיקה של אוקטובר.",
    "keyLabel": "מפתח API v3 (מתחיל ב-phk_)",
    "keyPlaceholder": "phk_…",
    "fingerprint": "טביעת אצבע של המפתח: {{fp}} — השאירו ריק כדי לשמור",
    "save": "שמירת מפתח v3",
    "saving": "שומר…",
    "saved": "מפתח PracticeHub v3 נשמר.",
    "accepted": "נשמר — PracticeHub v3 קיבל את המפתח.",
    "readOnlyWarn": "המפתח הזה יכול לכתוב. צרו מפתח לקריאה בלבד עבור MSK Insight ושמרו אותו במקום.",
    "tzWarn": "אזור הזמן של החשבון הוא {{tz}}. ‏MSK Insight קורא את שעות המרפאה כ-Europe/Nicosia, ולכן קריאת תורים דרך v3 תידחה עד שזה ייפתר.",
    "refused": "נשמר, אבל PracticeHub דחה אותו. ודאו שהעתקתם את המפתח המלא.",
    "rateLimited": "נשמר, אבל PracticeHub מגביל בקשות כרגע. הוא ייבדק שוב בשמירה הבאה.",
    "untested": "נשמר, אבל לא ניתן היה להגיע ל-PracticeHub כדי לבדוק אותו.",
    "isLegacy": "זהו מפתח API ישן של PracticeHub. הוא שייך לשדה המפתח הישן למעלה; השדה הזה מקבל רק מפתחות של ה-API החדש שמתחילים ב-phk_. דבר לא נשמר.",
    "invalidShape": "זה לא מפתח API v3 של PracticeHub. העתיקו אותו שוב מ-PracticeHub ← Developers ← API Keys. דבר לא נשמר.",
    "notConfigured": "שמרו מפתח PracticeHub v3 לפני העברת משאב ל-v3.",
    "writeKeyLabel": "מפתח כתיבה v3 (מתחיל ב-phk_)",
    "writeKeyHint": "מפתח שני, עם הרשאת כתיבה, המשמש אך ורק לשליחת דוחות. קריאות וסנכרונים לעולם אינם משתמשים בו. צרו אותו ב-PracticeHub ← Developers ← API Keys עם Access level: Read and write.",
    "writeSave": "שמירת מפתח כתיבה v3",
    "writeSaved": "מפתח הכתיבה של PracticeHub v3 נשמר.",
    "writeAccepted": "נשמר — PracticeHub v3 קיבל את המפתח, והוא יכול לכתוב.",
    "writeNoScope": "נשמר, אך מפתח זה אינו יכול לכתוב. צרו מפתח עם Access level: Read and write לשליחת דוחות.",
    "writeUntested": "נשמר, אך לא ניתן היה להתחבר ל-PracticeHub כדי לבדוק אותו.",
    "patientsNeedsMrn": "מתג המטופלים נשאר כבוי עד ש-PracticeHub יאשר באיזה שדה ב-v3 נמצא מספר המטופל (MRN). עד אז המטופלים ממשיכים להסתנכרן דרך החיבור הישן וכל מספר MRN קיים נשמר.",
    "patientsCheckFirst": "הפעלת המטופלים בודקת תחילה 20 מטופלים בזמן אמת: לכל אחד חייב להיות מספר מטופל (MRN) ב-v3, זהה למספר שבחיבור הישן.",
    "waitingForMigration": "ממתין להעברת הנתונים של PracticeHub: ל-{{populated}} מתוך {{checked}} המטופלים שנבדקו יש מספר מטופל ב-v3, ו-{{equal}} תואמים למספר בחיבור הישן. מתג המטופלים נשאר כבוי וכל מספר MRN קיים נשמר.",
    "mrnCheckFailed": "בדיקת מספרי המטופלים לא הצליחה להגיע ל-PracticeHub, ולכן מתג המטופלים נשאר כבוי. נסו שוב בעוד כמה דקות.",
    "saveFailed": "לא ניתן היה לשמור את הגדרות PracticeHub v3.",
    "switchesTitle": "קריאה מ-v3, לפי משאב",
    "switchesHint": "הכול כבוי עד הבדיקה החיה של אוקטובר. משאב כבוי נקרא מה-API הישן, בדיוק כמו היום.",
    "resource": {
      "patients": "מטופלים",
      "appointments": "תורים",
      "practitioners": "מטפלים",
      "files": "קבצים",
      "clinical_notes": "הערות קליניות"
    },
    "saveSwitches": "שמירת מתגים",
    "switchesSaved": "המתגים נשמרו.",
    "pushesLabel": "שליחת דוחות ל-PracticeHub דרך v3",
    "pushesHint": "כבוי: הדוחות נשלחים דרך החיבור הישן, כמו היום. מופעל: ההערה וקובצי ה-PDF נשלחים דרך v3 עם מפתח הכתיבה, כל אחד עם ההפניה שלנו, כך שתשובה שאבדה תימצא שוב במקום להישלח פעמיים.",
    "pushesOn": "הדוחות נשלחים כעת ל-PracticeHub דרך v3.",
    "pushesOff": "הדוחות נשלחים כעת ל-PracticeHub דרך החיבור הישן.",
    "pushesNeedWriteKey": "יש לשמור קודם מפתח כתיבה של v3."
  },
  "quickReportDetour": {
    "question": "להוסיף סריקת יציבה או הדמיה לפני שממשיכים?",
    "hint": "אפשר להוסיף עכשיו דוח PostureScreen או הדמיה; אחר כך תחזרו לאבחנה.",
    "addPosture": "הוספת סריקת יציבה",
    "addImaging": "הוספת הדמיה",
    "no": "לא, להמשיך",
    "bannerText": "כשתסיימו להוסיף את מה שצריך, המשיכו לאבחנה.",
    "returnButton": "המשך לאבחנה"
  },
  "phFiles": {
    "title_one": "קובץ {{count}} ב-PracticeHub",
    "title_two": "{{count}} קבצים ב-PracticeHub",
    "title_other": "{{count}} קבצים ב-PracticeHub",
    "none": "אין קבצים של מטופל זה ב-PracticeHub.",
    "unnamed": "(ללא שם קובץ)",
    "listOnly": "רשימה מ-PracticeHub; פתחו אותם ב-PracticeHub.",
    "rateLimited": "קבצי PracticeHub אינם זמינים זמנית. הם יוצגו שוב בקרוב."
  },
  "imagingStudy": {
    "title": "בדיקת הדמיה",
    "imagesCount_one": "תמונה אחת",
    "imagesCount_two": "{{count}} תמונות",
    "imagesCount_other": "{{count}} תמונות",
    "status_uploaded": "טרם נקרא",
    "status_analysed": "הסיכום ממתין לבדיקה",
    "status_accepted": "הסיכום אושר",
    "analyse": "קריאת כל {{count}} התמונות יחד",
    "analysing": "קורא את הבדיקה…",
    "accept": "אישור הסיכום",
    "reviewLines": "בדיקת שורות",
    "hideLines": "הסתרת בדיקת השורות",
    "edit": "עריכה",
    "save": "שמירה",
    "cancel": "ביטול",
    "reject": "דחייה",
    "rejected": "נדחה",
    "edited": "נערך",
    "series": "סדרות",
    "findings": "ממצאים",
    "measurements": "מדידות",
    "impressions": "התרשמויות",
    "pendingNote": "תצפית בסיוע בינה מלאכותית. דבר מכאן אינו מגיע לאבחנה או לדוח עד שתאשרו את הסיכום.",
    "acceptedNote": "תצפית בסיוע בינה מלאכותית, הסיכום אושר על ידי הקלינאי. שורות שאושרו או נערכו משמשות באבחנה ובסעיף הבדיקות של הדוח.",
    "excluded_one": "קובץ אחד לא נקרא על ידי הבינה המלאכותית (ניתן לנתח רק תמונות JPEG,‏ PNG או WebP).",
    "excluded_two": "{{count}} קבצים לא נקראו על ידי הבינה המלאכותית (ניתן לנתח רק תמונות JPEG,‏ PNG או WebP).",
    "excluded_other": "{{count}} קבצים לא נקראו על ידי הבינה המלאכותית (ניתן לנתח רק תמונות JPEG,‏ PNG או WebP).",
    "groupUnassigned": "קריאת {{count}} התמונות הקודמות יחד כבדיקה אחת",
    "regionMatch": "אזור ההדמיה תואם את אזור התלונה.",
    "regionMismatch": "התמונות מראות {{imaging}}, אבל אזור התלונה הוא {{complaint}}. ודאו שהתמונות שייכות לתלונה זו לפני האישור.",
    "regionUnknown": "לא ניתן היה לזהות את אזור ההדמיה מהתמונות; השוו אותו בעצמכם לאזור התלונה.",
    "regionNoComplaint": "להערכה זו אין אזור תלונה להשוואה עם ההדמיה.",
    "failed": "הפעולה נכשלה: {{message}}",
    "region": {
      "cervical": "עמוד שדרה צווארי",
      "thoracic": "עמוד שדרה חזי",
      "lumbar": "עמוד שדרה מותני",
      "sacral": "עצה/אגן",
      "shoulder": "כתף",
      "elbow": "מרפק",
      "wrist_hand": "שורש כף היד/כף היד",
      "hip": "ירך",
      "knee": "ברך",
      "ankle_foot": "קרסול/כף הרגל",
      "tmj": "לסת (TMJ)"
    },
    "reportAttached": "+ דוח רדיולוג",
    "radiologistReport": "דוח הרדיולוג (כלשונו)",
    "radFindings": "ממצאי הרדיולוג",
    "radImpression": "רושם הרדיולוג",
    "aiObservations": "תצפיות הבינה המלאכותית בתמונות",
    "disagreeBanner": "תצפיות הבינה המלאכותית חולקות על דוח הרדיולוג:",
    "radSays": "רדיולוג",
    "aiSays": "בינה מלאכותית",
    "agreeNote": "תצפיות הבינה המלאכותית תואמות את דוח הרדיולוג.",
    "compareUnavailable": "לא ניתן היה להשוות בין דוח הרדיולוג לתצפיות הבינה המלאכותית: {{note}}",
    "aiUnavailable": "תצפיות הבינה המלאכותית בתמונות אינן זמינות ({{note}}). דוח הרדיולוג מוצג לבדו.",
    "reportUnrecognised": "הועלה PDF יחד עם התמונות, אך לא נמצא בו סעיף ממצאים או רושם. קראו את הדוח עצמו."
  },
  "postureCapture": {
    "title": "צילום יציבה",
    "steps": "שלבי צילום היציבה",
    "step": {
      "setup": "מפגש",
      "photos": "תמונות",
      "wall": "מדידות קיר",
      "mark": "סימון הנקודות",
      "summary": "סיכום"
    },
    "script": "עמדו כפי שאתם עומדים בדרך כלל. אל תזדקפו בשביל המצלמה. הביטו ישר קדימה.",
    "kind": {
      "label": "סוג מפגש",
      "normal": "רגיל",
      "stand_tall": "עמידה זקופה",
      "repeat_test": "בדיקה חוזרת"
    },
    "week": {
      "label": "שבוע",
      "none": "ללא שבוע",
      "w0": "שבוע 0",
      "w6": "שבוע 6",
      "w12": "שבוע 12"
    },
    "settings": {
      "cameraDistanceCm": "מרחק המצלמה (ס\"מ)",
      "lensHeightCm": "גובה העדשה (ס\"מ)",
      "floorMark": "נעשה שימוש בסימון הרצפה",
      "defaultsHint": "ברירות המחדל הן ההתקנה הסטנדרטית של המרפאה. שנו אותן רק אם המצלמה הוצבה אחרת היום."
    },
    "createSession": "יצירת מפגש",
    "creating": "יוצר את המפגש...",
    "sessionCreated": "המפגש נוצר",
    "view": {
      "front": "חזית",
      "back": "גב",
      "left": "צד שמאל",
      "right": "צד ימין"
    },
    "photos": {
      "hint": "עד {{max}} תמונות לכל מבט, JPEG או PNG. כל תמונה מועלית מיד עם בחירתה.",
      "takePhoto": "צילום תמונה",
      "chooseFile": "בחירת קובץ",
      "limit": "למבט זה כבר יש {{max}} תמונות.",
      "uploading": "מעלה...",
      "uploaded": "הועלה",
      "failed": "ההעלאה נדחתה",
      "refusedType": "מתקבלות רק תמונות JPEG או PNG.",
      "refusedSize": "התמונה גדולה מ-15 MB.",
      "empty": "אין תמונה עדיין",
      "thumbAlt": "תמונת {{view}} {{index}}"
    },
    "wall": {
      "title": "מדידות ראש-קיר",
      "hint": "שלוש מדידות בסנטימטרים, כשהאדם עומד עם הגב לקיר.",
      "reading": "מדידה {{n}} (ס\"מ)",
      "save": "שמירת המדידות",
      "saved": "המדידות נשמרו",
      "invalid": "הזינו שלושה מספרים של אפס סנטימטרים ומעלה."
    },
    "mark": {
      "next": "סמנו",
      "complete": "כל הנקודות הונחו",
      "undo": "ביטול הנקודה האחרונה",
      "redo": "סימון מחדש של מבט זה",
      "save": "שמירת הנקודות",
      "saved": "הנקודות נשמרו",
      "earlierHidden": "מספרי המפגשים הקודמים אינם מוצגים בזמן הסימון.",
      "noCaptures": "אין תמונות עדיין. הוסיפו תמונות תחילה.",
      "loadingImage": "טוען את התמונה...",
      "imageAlt": "תמונת {{view}} {{index}}, הקישו כדי להניח נקודה"
    },
    "landmark": {
      "tragus": "נקודת האוזן (טראגוס)",
      "c7": "בסיס הצוואר (C7)",
      "leftEar": "אוזן שמאל",
      "rightEar": "אוזן ימין",
      "leftShoulder": "כתף שמאל",
      "rightShoulder": "כתף ימין"
    },
    "summary": {
      "title": "סיכום הצילום",
      "noVerdict": "זוויות ובדיקת הצילום בלבד. אין ציון, תוצאה או דוח במסך זה.",
      "noneMarked": "לא נשמרו נקודות למבט זה.",
      "neckAngle": "זווית הצוואר",
      "shoulderLine": "הטיית קו הכתפיים",
      "headLine": "הטיית קו הראש",
      "mean": "ממוצע",
      "spread": "פיזור",
      "needsRemark": "נדרש סימון מחדש: התמונות אינן מסכימות",
      "agree": "התמונות מסכימות",
      "settings": "בדיקת התקנת הצילום",
      "settingsOk": "ההתקנה בתוך הסבולות הסטנדרטיות.",
      "nominal": "סטנדרט",
      "remark": "סימון הנקודות מחדש"
    },
    "next": "הבא",
    "error": {
      "generic": "השרת דחה את הבקשה."
    }
  }
}
